import "./PayrollDataGridStyle.css";

import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	RHookFormNumberField,
	RequestParams,
} from "@websential/cosmic-v20";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from "react";
import {
	clearStickyCheckboxHighlight,
	refreshStickyGrid,
	registerStickyGrid,
	unregisterStickyGrid,
} from "../stickyHeaderManager";
import { formatAmountCommaSeperator, formatAmountToFloat, formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount, getValueByFieldPath } from "../../../common/Common";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Skeleton } from "primereact/skeleton";
import isEqual from "lodash/isEqual";

export interface IPayrollDataGrid {
	rows: any;
	originalPayrollDataItems: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: string;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	PayrollTableData: (data: any) => void;
	vocationalEarningsList: any
	clearAllSelectedItemsForPayrollTable: string | number;
	selectedPayPeriod: any;
	pageScrollContainerRef?: React.RefObject<HTMLElement>;
	gridsMaxTotalWidth?: any;
	enableFrozenColumns?: boolean;
}

// interface PayrollNumberCellProps {
// 	value: any;
// 	cellKey: string;
// 	column: any;
// 	rowIndex: number;
// 	employeeId: number;
// 	rowData: any;
// 	onCellValueChange: (
// 		column: any,
// 		rowIndex: number,
// 		value: any,
// 		rowData: any
// 	) => void;
// 	setActiveRowIndex: React.Dispatch<React.SetStateAction<number | null>>;
// 	inputRefs: React.MutableRefObject<
// 		Record<string, HTMLInputElement | null>
// 	>;
// 	handleCellNavigation: (
// 		e: React.KeyboardEvent<HTMLInputElement>,
// 		rowIndex: number,
// 		column: any
// 	) => void;
// 	inputClassName: string;
// }

// const PayrollNumberCell = React.memo(
// 	({
// 		value,
// 		cellKey,
// 		column,
// 		rowIndex,
// 		employeeId,
// 		rowData,
// 		onCellValueChange,
// 		setActiveRowIndex,
// 		inputRefs,
// 		handleCellNavigation,
// 		inputClassName,
// 	}: PayrollNumberCellProps) => {
// 		const lastValueRef = useRef(value);
// 		return (
// 			<InputNumber
// 				value={value}
// 				minFractionDigits={2}
// 				maxFractionDigits={2}
// 				inputClassName={inputClassName}
// 				inputStyle={{
// 					textAlign: "right",
// 				}}
// 				// inputRef={(el) => {
// 				// 	inputRefs.current[cellKey] = el;
// 				// }}
// 				inputRef={(el) => {
// 					if (el) {
// 						inputRefs.current[cellKey] = el;
// 					} else {
// 						delete inputRefs.current[cellKey];
// 					}
// 				}}
// 				onFocus={() => {
// 					setActiveRowIndex(employeeId);
// 				}}
// 				onBlur={() => {
// 					const raw = inputRefs.current[cellKey]?.value;

// 					const edited =
// 						raw === "" || raw == null
// 							? null
// 							: Number(raw.replace(/,/g, ""));

// 					onCellValueChange(
// 						column,
// 						rowIndex,
// 						edited,
// 						rowData
// 					);
// 				}}
// 				onKeyDown={(e) => {
// 					handleCellNavigation(
// 						e,
// 						rowIndex,
// 						column
// 					);
// 				}}
// 			/>
// 		);
// 	}
// );

// interface PayrollNumberCellProps {
// 	value: any;
// 	cellKey: string;
// 	column: any;
// 	rowIndex: number;
// 	employeeId: number;
// 	rowData: any;
// 	onCellValueChange: (
// 		column: any,
// 		rowIndex: number,
// 		value: any,
// 		rowData: any
// 	) => void;
// 	setActiveRowIndex: React.Dispatch<
// 		React.SetStateAction<number | null>
// 	>;
// 	inputRefs: React.MutableRefObject<
// 		Record<string, HTMLInputElement | null>
// 	>;
// 	setInputRef: (
// 		cellKey: string,
// 		element: HTMLInputElement | null
// 	) => void;
// 	handleCellNavigation: (
// 		e: React.KeyboardEvent<HTMLInputElement>,
// 		rowIndex: number,
// 		column: any
// 	) => void;
// 	inputClassName: string;
// }

// const PayrollNumberCell = React.memo(
// 	({
// 		value,
// 		cellKey,
// 		column,
// 		rowIndex,
// 		employeeId,
// 		rowData,
// 		onCellValueChange,
// 		setActiveRowIndex,
// 		inputRefs,
// 		setInputRef,
// 		handleCellNavigation,
// 		inputClassName,
// 	}: PayrollNumberCellProps) => {
// 		const editingValueRef = useRef<string>("");

// 		const displayValue = useMemo(() => {
// 			if (
// 				value === null ||
// 				value === undefined ||
// 				value === ""
// 			) {
// 				return "";
// 			}

// 			const numericValue = Number(
// 				String(value).replace(/,/g, "")
// 			);

// 			if (Number.isNaN(numericValue)) {
// 				return String(value);
// 			}

// 			return numericValue.toFixed(2);
// 		}, [value]);

// 		return (
// 			<input
// 				ref={(element) => {
// 					if (element) {
// 						inputRefs.current[cellKey] =
// 							element;
// 					} else {
// 						delete inputRefs.current[
// 							cellKey
// 						];
// 					}
// 				}}

// 				type="text"

// 				inputMode="decimal"

// 				defaultValue={displayValue}

// 				className={inputClassName}

// 				style={{
// 					textAlign: "right",
// 					width: "100%",
// 					border: 0,
// 					outline: "none",
// 					background: "transparent",
// 					font: "inherit",
// 					padding: 0,
// 				}}

// 				onFocus={(e) => {
// 					editingValueRef.current =
// 						e.currentTarget.value;

// 					setActiveRowIndex(
// 						employeeId
// 					);
// 				}}

// 				onChange={(e) => {
// 					editingValueRef.current =
// 						e.currentTarget.value;
// 				}}

// 				onBlur={(e) => {
// 					const raw =
// 						e.currentTarget.value;

// 					const edited =
// 						raw.trim() === ""
// 							? null
// 							: Number(
// 								raw.replace(
// 									/,/g,
// 									""
// 								)
// 							);

// 					onCellValueChange(
// 						column,
// 						rowIndex,
// 						Number.isNaN(
// 							edited as number
// 						)
// 							? null
// 							: edited,
// 						rowData
// 					);
// 				}}

// 				onKeyDown={(e) => {
// 					handleCellNavigation(
// 						e,
// 						rowIndex,
// 						column
// 					);
// 				}}
// 			/>
// 		);
// 	},
// 	(prev, next) => {
// 		return (
// 			prev.value === next.value &&
// 			prev.cellKey === next.cellKey &&
// 			prev.rowIndex === next.rowIndex &&
// 			prev.employeeId ===
// 			next.employeeId &&
// 			prev.inputClassName ===
// 			next.inputClassName &&
// 			prev.column === next.column &&
// 			prev.rowData === next.rowData
// 		);
// 	}
// );

// PayrollNumberCell.displayName =
// 	"PayrollNumberCell";

// PayrollNumberCell.displayName = "PayrollNumberCell";

// const sanitizeNumberInput = (e: any) => {
// 	const input = e.currentTarget;
// 	let value = input.value.replace(/[^\d.-]/g, "");
// 	const parts = value.split(".");
// 	if (parts.length > 2) value = `${parts[0]}.${parts.slice(1).join("")}`;
// 	const decimalParts = value.split(".");
// 	if (decimalParts.length === 2) {
// 		value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
// 	}
// 	input.value = value;
// };

// const NumberCell = React.memo(function NumberCell({
// 	rowIndex,
// 	field,
// 	employeeId,
// 	displayValue,
// 	className,
// 	registerRef,
// }: any) {
// 	const inputRef: any = useRef(null);

// 	useLayoutEffect(() => {
// 		const el = inputRef.current;
// 		if (el && document.activeElement !== el && el.value !== displayValue) {
// 			el.value = displayValue;
// 		}
// 	}, [displayValue]);

// 	return (
// 		<input
// 			ref={(el) => {
// 				inputRef.current = el;
// 				registerRef(el);
// 			}}
// 			data-payroll-input="true"
// 			data-row-index={rowIndex}
// 			data-field={field}
// 			data-employee-id={employeeId}
// 			type="text"
// 			inputMode="decimal"
// 			autoComplete="off"
// 			autoCorrect="off"
// 			autoCapitalize="off"
// 			spellCheck={false}
// 			data-lpignore="true"        // tells LastPass to skip this field
// 			data-1p-ignore="true"       // tells 1Password to skip this field
// 			data-bwignore="true"        // Bitwarden
// 			data-form-type="other"      // generic signal to various extensions
// 			name={`cell-${employeeId}-${field}`}  // avoid generic/guessable names like "amount"
// 			defaultValue={displayValue}
// 			className={className}
// 			onInput={sanitizeNumberInput}
// 		/>

// 		// <></>
// 	);
// },
// 	(prev, next) =>
// 		prev.displayValue === next.displayValue &&
// 		prev.className === next.className &&
// 		prev.employeeId === next.employeeId &&
// 		prev.field === next.field &&
// 		prev.rowIndex === next.rowIndex
// );

// const NumberCell = React.memo(function NumberCell({
// 	rowIndex,
// 	field,
// 	employeeId,
// 	displayValue,
// 	className,
// 	registerRef,
// }: any) {
// 	const cellRef = useRef<HTMLDivElement | null>(null);

// 	useLayoutEffect(() => {
// 		const el = cellRef.current;
// 		if (el && document.activeElement !== el && el.textContent !== displayValue) {
// 			el.textContent = displayValue;
// 		}
// 	}, [displayValue]);

// 	return (
// 		<div
// 			ref={(el) => {
// 				cellRef.current = el;
// 				registerRef(el);
// 			}}
// 			data-payroll-input="true"
// 			data-row-index={rowIndex}
// 			data-field={field}
// 			data-employee-id={employeeId}
// 			contentEditable
// 			suppressContentEditableWarning
// 			className={className}
// 			style={{ textAlign: "right", outline: "none", whiteSpace: "nowrap" }}
// 			onInput={(e) => {
// 				const el = e.currentTarget;
// 				let value = el.textContent || "";
// 				value = value.replace(/[^\d.-]/g, "");
// 				const parts = value.split(".");
// 				if (parts.length > 2) value = `${parts[0]}.${parts.slice(1).join("")}`;
// 				const decimalParts = value.split(".");
// 				if (decimalParts.length === 2) {
// 					value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
// 				}
// 				if (value !== el.textContent) {
// 					const sel = window.getSelection();
// 					el.textContent = value;
// 					// restore caret to end after correction — keep it simple, put caret at end
// 					const range = document.createRange();
// 					range.selectNodeContents(el);
// 					range.collapse(false);
// 					sel?.removeAllRanges();
// 					sel?.addRange(range);
// 				}
// 			}}
// 		>
// 			{displayValue}
// 		</div>
// 	);
// },
// 	(prev, next) =>
// 		prev.displayValue === next.displayValue &&
// 		prev.className === next.className &&
// 		prev.employeeId === next.employeeId &&
// 		prev.field === next.field &&
// 		prev.rowIndex === next.rowIndex
// );


// const NumberCell = React.memo(function NumberCell({
// 	rowIndex,
// 	field,
// 	employeeId,
// 	displayValue,
// 	className,
// 	registerRef,
// }: any) {
// 	const inputRef = useRef<HTMLInputElement | null>(null);

// 	useLayoutEffect(() => {
// 		const el = inputRef.current;
// 		if (el && document.activeElement !== el && el.value !== displayValue) {
// 			el.value = displayValue;
// 		}
// 	}, [displayValue]);

// 	return (
// 		<input
// 			ref={(el) => {
// 				inputRef.current = el;
// 				registerRef(el);
// 			}}
// 			data-payroll-input="true"
// 			data-row-index={rowIndex}
// 			data-field={field}
// 			data-employee-id={employeeId}
// 			type="text"
// 			inputMode="decimal"
// 			autoComplete="off"
// 			defaultValue={displayValue}
// 			className={className}
// 			style={{ textAlign: "right" }}
// 			onInput={sanitizeNumberInput}
// 		/>
// 	);
// },
// 	(prev, next) =>
// 		prev.displayValue === next.displayValue &&
// 		prev.className === next.className &&
// 		prev.employeeId === next.employeeId &&
// 		prev.field === next.field &&
// 		prev.rowIndex === next.rowIndex
// );


// const NumberCell = React.memo(function NumberCell({
// 	rowIndex,
// 	field,
// 	employeeId,
// 	displayValue,
// 	className,
// 	registerRef,
// }: any) {
// 	const cellRef: any = useRef<HTMLDivElement | null>(null);

// 	useLayoutEffect(() => {
// 		const el = cellRef.current;
// 		if (el && document.activeElement !== el && el.textContent !== displayValue) {
// 			el.textContent = displayValue;
// 		}
// 	}, [displayValue]);

// 	return (
// 		<div
// 			ref={(el) => {
// 				cellRef.current = el;
// 				registerRef(el);
// 			}}
// 			data-payroll-input="true"
// 			data-row-index={rowIndex}
// 			data-field={field}
// 			data-employee-id={employeeId}
// 			contentEditable
// 			suppressContentEditableWarning
// 			className={className}
// 			style={{ textAlign: "right", outline: "none", whiteSpace: "nowrap" }}
// 			onInput={(e) => {
// 				const el = e.currentTarget;
// 				let value = el.textContent || "";
// 				value = value.replace(/[^\d.-]/g, "");
// 				const parts = value.split(".");
// 				if (parts.length > 2) value = `${parts[0]}.${parts.slice(1).join("")}`;
// 				const decimalParts = value.split(".");
// 				if (decimalParts.length === 2) {
// 					value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
// 				}
// 				if (value !== el.textContent) {
// 					const sel = window.getSelection();
// 					el.textContent = value;
// 					// restore caret to end after correction — keep it simple, put caret at end
// 					const range = document.createRange();
// 					range.selectNodeContents(el);
// 					range.collapse(false);
// 					sel?.removeAllRanges();
// 					sel?.addRange(range);
// 				}
// 			}}
// 		>
// 			{displayValue}
// 		</div>
// 	);
// },
// 	(prev, next) =>
// 		prev.displayValue === next.displayValue &&
// 		prev.className === next.className &&
// 		prev.employeeId === next.employeeId &&
// 		prev.field === next.field &&
// 		prev.rowIndex === next.rowIndex
// );

const placeCaretBeforeDecimal = (el: HTMLElement) => {
	const text = el.textContent ?? "";
	const decimalIndex = text.indexOf(".");
	const offset = decimalIndex >= 0 ? decimalIndex : text.length;

	const textNode = el.firstChild;
	const range = document.createRange();
	const sel = window.getSelection();

	if (textNode && textNode.nodeType === Node.TEXT_NODE) {
		const safeOffset = Math.min(offset, textNode.textContent?.length ?? 0);
		range.setStart(textNode, safeOffset);
		range.collapse(true);
	} else {
		range.selectNodeContents(el);
		range.collapse(false);
	}

	sel?.removeAllRanges();
	sel?.addRange(range);
};



const NumberCell = React.memo(function NumberCell({
	rowIndex,
	field,
	employeeId,
	displayValue,
	className,
	registerRef,
	column,        // CHANGED: needs the column object for handleCellNavigation
	onCellKeyDown, // CHANGED: passed from parent, bound to handleCellNavigation
}: any) {
	const cellRef: any = useRef<HTMLDivElement | null>(null);

	useLayoutEffect(() => {
		const el = cellRef.current;
		if (el && document.activeElement !== el && el.textContent !== displayValue) {
			el.textContent = displayValue;
		}
	}, [displayValue]);

	return (
		<div
			ref={(el) => {
				cellRef.current = el;
				registerRef(el);
			}}
			data-payroll-input="true"
			data-row-index={rowIndex}
			data-field={field}
			data-employee-id={employeeId}
			contentEditable
			suppressContentEditableWarning
			className={className}
			style={{ textAlign: "right", outline: "none", whiteSpace: "nowrap" }}
			onFocus={(e) => {
				// CHANGED: place caret before the decimal, matching input behavior
				requestAnimationFrame(() => placeCaretBeforeDecimal(e.currentTarget));
			}}
			onKeyDown={(e) => {
				// CHANGED: arrow-key navigation, matching input behavior
				onCellKeyDown && onCellKeyDown(e, rowIndex, column);
			}}
			onInput={(e) => {
				const el = e.currentTarget;
				let value = el.textContent || "";
				value = value.replace(/[^\d.-]/g, "");
				const parts = value.split(".");
				if (parts.length > 2) value = `${parts[0]}.${parts.slice(1).join("")}`;
				const decimalParts = value.split(".");
				if (decimalParts.length === 2) {
					value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
				}
				if (value !== el.textContent) {
					const sel = window.getSelection();
					el.textContent = value;
					const range = document.createRange();
					range.selectNodeContents(el);
					range.collapse(false);
					sel?.removeAllRanges();
					sel?.addRange(range);
				}
			}}
		>
			{displayValue}
		</div>
	);
},
	(prev, next) =>
		prev.displayValue === next.displayValue &&
		prev.className === next.className &&
		prev.employeeId === next.employeeId &&
		prev.field === next.field &&
		prev.rowIndex === next.rowIndex
);


export const PayrollDataGrid: React.FC<IPayrollDataGrid> = ({
	rows,
	originalPayrollDataItems,
	columns,
	showIndexColumn,
	showChecboxColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	PayrollTableData,
	vocationalEarningsList,
	clearAllSelectedItemsForPayrollTable,
	selectedPayPeriod,
	pageScrollContainerRef,
	gridsMaxTotalWidth,
	enableFrozenColumns = false,
}) => {
	const navigate = useNavigate();
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const [payrollItems, setPayrollItems] = useState<any>(
		rows && rows
	);


	// useEffect(() => {
	// 	PayrollTableData(payrollItems);

	// }, [payrollItems]);

	// in PayrollDataGrid, convert to forwardRef
	const payrollItemsRef = useRef(payrollItems);
	// useEffect(() => { payrollItemsRef.current = payrollItems; }, [payrollItems]);

	const notifyTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	// useEffect(() => {
	// 	if (notifyTimerRef.current) clearTimeout(notifyTimerRef.current);
	// 	notifyTimerRef.current = setTimeout(() => {
	// 		PayrollTableData(payrollItemsRef.current);
	// 	}, 300);
	// 	return () => { if (notifyTimerRef.current) clearTimeout(notifyTimerRef.current); };
	// }, [payrollItems]);

	// useEffect(() => {
	// 	payrollItemsRef.current = payrollItems;
	// }, [payrollItems]);

	// Notify parent, but skip if this payrollItems is identical to what we last sent
	const lastNotifiedRef = useRef<any>(null);
	useEffect(() => {
		if (notifyTimerRef.current) clearTimeout(notifyTimerRef.current);

		notifyTimerRef.current = setTimeout(() => {
			if (isEqual(lastNotifiedRef.current, payrollItemsRef.current)) return;
			lastNotifiedRef.current = payrollItemsRef.current;
			PayrollTableData(payrollItemsRef.current);
		}, 300);

		return () => {
			if (notifyTimerRef.current) clearTimeout(notifyTimerRef.current);
		};
	}, [payrollItems]);



	// useEffect(() => {
	// 	if (!isEqual(rows, payrollItems)) {
	// 		setPayrollItems([...rows]);
	// 	}
	// }, [rows]);

	// useEffect(() => {
	// 	setPayrollItems(rows ?? []);
	// }, [rows]);

	// Sync rows -> local state, but skip if nothing actually changed
	const lastRowsRef = useRef(rows);
	useEffect(() => {
		if (isEqual(lastRowsRef.current, rows)) {
			return;
		}
		lastRowsRef.current = rows;
		setPayrollItems(rows ?? []);
	}, [rows]);


	const sortedColumns = useMemo(
		() =>
			columns
				? [...columns].sort(
					(a: any, b: any) =>
						(a.sequence ?? 0) -
						(b.sequence ?? 0)
				)
				: [],
		[columns]
	);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [itemSearsch, setItemSearsch] = useState("");
	// this is for select all checkbox in footer bottom
	const [manualSelectAll, setManualSelectAll] = useState<any>(false);
	const onSearchButtonClicked = () => {
		// setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		// setTimeout(() => {
		// 	setLoading(false);
		// }, 1000);
	};
	const handleClearSearch = () => {
		// setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		// setTimeout(() => {
		// 	setLoading(false);
		// }, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();

	const onPage = (event: any) => {
		// setRequestParams(event);
		// setLoading(true);
		//imitate delay of a backend call
		// setTimeout(() => {
		// 	setRequestParams({
		// 		...event,
		// 		searchQuery: itemSearch,
		// 	});
		// 	setLoading(false);
		// }, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			// setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// Imitate delay of a backend call
			// setTimeout(() => {
			// 	setLoading(false);
			// }, 1000);
		},
		[sortOrder, sortField]
	);
	// // This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	// useEffect(() => {
	// 	// if the results fetcher was passed, we can use it to fetch the results.
	// 	if (onRequestParamsChange) {
	// 		// skip the first initial call
	// 		if (isInitialRequest.current === true) {

	// 			isInitialRequest.current = false;
	// 		} else {

	// 			onRequestParamsChange(requestParams);
	// 		}
	// 	}
	// }, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			// this is for select all checkbox in footer bottom
			setManualSelectAll(
				!!(rows?.length && updatedSelectedItems.length === rows.length)
			);
			// if (selectedRowsValues) {
			// 	if (items.value.length > 0) {
			// 		const selectedRowData = rows.filter((row: any) => {
			// 			return items.value.includes(row);
			// 		});

			// 		selectedRowsValues(selectedRowData);
			// 	} else {
			// 		selectedRowsValues(items.value);

			// 	}
			// }
		},
		[rows, selectedItems]
	);
	// useEffect(() => {
	// 	// Check for deleted items and remove them from selectedItems
	// 	const updatedSelectedItems =
	// 		selectedItems &&
	// 		selectedItems.length > 0 &&
	// 		selectedItems.filter((selectedItem: any) => {
	// 			return rows && rows.find((row: any) => row.id === selectedItem.id);
	// 		});
	// 	// Only update if there are changes to selectedItems
	// 	if (
	// 		updatedSelectedItems &&
	// 		updatedSelectedItems.length !== selectedItems.length
	// 	) {
	// 		setSelectedItems(updatedSelectedItems);

	// 		// Update selectedItemsIds
	// 		const updatedSelectedItemsIds = updatedSelectedItems.map(
	// 			(item: any) => item.id
	// 		);
	// 		setSelectedItemsIds(updatedSelectedItemsIds);
	// 	}
	// }, [rows, selectedItems]);
	useEffect(() => {
		if (selectedItems && selectedItems.length > 0) {
			// Check if all selected items exist in rows
			const allExist = selectedItems.every((selectedItem: any) =>
				rows?.some((row: any) => row.employeeId === selectedItem.employeeId)
			);
			if (!allExist) {
				// ❌ One or more items removed → reset to initial state
				setSelectedItems([]);
				setSelectedItemsIds([]);
				if (selectedRowsValues) selectedRowsValues([]);
			}
		}
	}, [rows]);

	// useEffect(() => {
	// 	if (selectedItems && selectedItems.length > 0 && clearAllSelectedItemsForPayrollTable === 'delete') {
	// 		setSelectedItems([]);
	// 		setSelectedItemsIds([]);
	// 		selectedRowsValues([]);
	// 	}
	// }, [clearAllSelectedItemsForPayrollTable]);

	const isInitialClearRender = useRef(true);
	useEffect(() => {
		if (isInitialClearRender.current) {
			isInitialClearRender.current = false;
			return;
		}
		setSelectedItems([]);
		setSelectedItemsIds([]);
		setManualSelectAll(false);
		// setActiveRowIndex(null)
		if (selectedRowsValues) selectedRowsValues([]);
	}, [clearAllSelectedItemsForPayrollTable]);


	// const onCellValueChange = (column: any, rowIndex: number, value: any) => {

	// 	// setPayrollItems((prev: any) => {
	// 	// 	const updatedData = [...prev];
	// 	// 	const updatedRow = { ...updatedData[rowIndex], [event.field]: field };


	// 	// 	updatedData[rowIndex] = updatedRow;
	// 	// 	return updatedData;
	// 	// });
	// };

	let listttt = [
		"grossIncome", //Gross
		"ot1Dot5Hours", //ot 1.5 
		"Commission",
		"Over Time 1.5",
		"Over Time 2.0",
		"Bonus",
		"Non-Periodic Payment",
		"Retroactive Pay Increase",
		"Holiday Pay"
	]

	// const onCellValueChange = (column: any, rowIndex: number, value: any, rowData?: any) => {
	// 	// if (showChecboxColumn) {
	// 	// 	setPayrollItems((prev: any[]) => {
	// 	// 		const updatedData = [...prev];
	// 	// 		const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 	// 		updatedData[rowIndex] = updatedRow;

	// 	// 		// Fix: re-map selectedItems to updatedData references
	// 	// 		setSelectedItems((prevSelected: any[]) =>
	// 	// 			prevSelected
	// 	// 				.map(sel => updatedData.find(r => r.id === sel.id))
	// 	// 				.filter(Boolean)
	// 	// 		);

	// 	// 		return updatedData;
	// 	// 	});
	// 	// } else {
	// 	// 	setPayrollItems((prev: any[]) => {
	// 	// 		const updatedData = [...prev];
	// 	// 		const updatedRow = updatedData[rowIndex];

	// 	// 		// mutate only the needed field (keeps same object reference)
	// 	// 		updatedRow[column.field] = value;

	// 	// 		return updatedData;
	// 	// 	});
	// 	// }
	// 	if (showChecboxColumn) {
	// 		if (vocationalEarningsList && vocationalEarningsList.length > 0) {
	// 			const isVocationable = vocationalEarningsList.includes(column.field);
	// 			// const isVocationable = vocationalEarningsList.includes("Regular Gross")
	// 	


	// 			setPayrollItems((prev: any[]) => {
	// 				const updatedData = [...prev];
	// 				const updatedRow = { ...updatedData[rowIndex] };


	// 				// always update the edited field first
	// 				updatedRow[column.field] = value;

	// 				if (isVocationable) {
	// 					// 1️⃣ Sum all vocational field values (including this one)
	// 					let totalSum = 0;

	// 					vocationalEarningsList.forEach((vocField: string | number) => {
	// 						
	// 						const fieldValue =
	// 							vocField === column.field
	// 								? value
	// 								: Number(updatedRow[vocField]) || 0;
	// 						totalSum += fieldValue;

	// 					});
	// 				


	// 					// 2️⃣ Calculate 4% of total
	// 					const calculatedValue = (totalSum * 4) / 100;
	// 					
	// 					if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
	// 						const vacationPayDueField = "vacationPayAccured";
	// 						// const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
	// 						// // const existingValue = Number(updatedRow[vacationPayDueField]) || 0;
	// 						// const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
	// 						// if (calculatedValue !== 0) {

	// 						// 	const newValue = existingValue + calculatedValue;
	// 						

	// 						// 	// ✅ Round to 2 decimal places
	// 						// 	updatedRow[vacationPayDueField] = Math.round(newValue * 100) / 100;
	// 						// } else {
	// 						// 	const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
	// 						
	// 						// 	updatedRow[vacationPayDueField] = Math.round(initialRowValue.vacationPayAccured * 100) / 100;

	// 						// }

	// 						updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;


	// 					} else {
	// 						updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;



	// 					
	// 						// const vacationPayDueField = "vacationPayAccured";
	// 						// updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;
	// 					}
	// 				}

	// 				// Update table data
	// 				updatedData[rowIndex] = updatedRow;

	// 				// Update selected items
	// 				setSelectedItems((prevSelected: any[]) =>
	// 					prevSelected
	// 						.map((sel) => updatedData.find((r) => r.id === sel.id))
	// 						.filter(Boolean)
	// 				);

	// 				return updatedData;
	// 			});
	// 		} else {
	// 			setPayrollItems((prev: any[]) => {
	// 				const updatedData = [...prev];
	// 				const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 				updatedData[rowIndex] = updatedRow;

	// 				// Fix: re-map selectedItems to updatedData references
	// 				setSelectedItems((prevSelected: any[]) =>
	// 					prevSelected
	// 						.map(sel => updatedData.find(r => r.id === sel.id))
	// 						.filter(Boolean)
	// 				);

	// 				return updatedData;
	// 			});
	// 		}
	// 	} else {
	// 		setPayrollItems((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = updatedData[rowIndex];

	// 			// mutate only the needed field (keeps same object reference)
	// 			updatedRow[column.field] = value;

	// 			return updatedData;
	// 		});
	// 	}
	// };

	// const setValueByFieldPath = (obj: any, path: string, value: any) => {
	// 	const parts = path.split('.');
	// 	if (parts.length === 1) {
	// 		obj[path] = value;
	// 	} else {
	// 		// e.g. path = "customAmounts.Ear Voc"
	// 		const [parent, ...rest] = parts;
	// 		if (!obj[parent]) obj[parent] = {};
	// 		setValueByFieldPath(obj[parent], rest.join('.'), value);
	// 	}
	// };


	// old with earninds dot issue like ear.1
	// const setValueByFieldPath = (
	// 	obj: any,
	// 	path: string,
	// 	value: any
	// ) => {
	// 	const parts = path.split(".");

	// 	if (parts.length === 1) {
	// 		obj[path] = value;
	// 		return;
	// 	}

	// 	let current = obj;

	// 	for (let i = 0; i < parts.length - 1; i++) {
	// 		const part = parts[i];

	// 		if (!current[part]) {
	// 			current[part] = {};
	// 		}

	// 		current = current[part];
	// 	}

	// 	current[parts[parts.length - 1]] = value;
	// };

	const setValueByFieldPath = (
		obj: any,
		path: string,
		value: any
	) => {
		const dotIndex = path.indexOf(".");

		if (dotIndex === -1) {
			obj[path] = value;
			return;
		}

		const parent = path.substring(0, dotIndex);
		const key = path.substring(dotIndex + 1);

		if (!obj[parent]) {
			obj[parent] = {};
		}

		obj[parent][key] = value;
	};

	// Helper — put this above the block, or as a component-level function
	const validateHoursLimit = (
		fieldName: string,
		total: number,
		updatedRow: any,
		selectedPayPeriod: any,
		onSnackbarMessageData: any,
		cellKey?: string
	) => {
		const limits: Record<number, number> = {
			12: 744,
			26: 336,
			52: 168,
			24: 384,
		};

		const payPeriodCode = selectedPayPeriod?.payPeriodCode;
		const limit = payPeriodCode != null ? limits[payPeriodCode] : undefined;

		if (limit !== undefined && total > limit) {
			onSnackbarMessageData &&
				onSnackbarMessageData({
					open: true,
					message: `Sum of all hours cannot be greater than ${limit} for this Pay Period`,
					severity: "error",
				});
			updatedRow[fieldName] = 0; // ✅ numeric, so InputNumber actually re-renders as 0
			if (cellKey && inputRefs.current[cellKey]) {
				inputRefs.current[cellKey]!.value = "0.00";
			}
			return false;
		}
		return true;
	};

	const originalPayrollMap = useMemo(() => {
		const map = new Map();

		for (const item of originalPayrollDataItems ?? []) {
			map.set(item.employeeId, item);
		}

		return map;
	}, [originalPayrollDataItems]);

	const payrollItemsMap = useMemo(() => {
		const map = new Map();

		for (const item of payrollItems) {
			map.set(item.employeeId, item);
		}

		return map;
	}, [payrollItems]);

	// old with earninds dot issue like ear.1
	// const getByPath = (
	// 	obj: any,
	// 	path: string
	// ) => {
	// 	const parts = path.split(".");

	// 	let current = obj;

	// 	for (const part of parts) {
	// 		if (current == null) {
	// 			return undefined;
	// 		}

	// 		current = current[part];
	// 	}

	// 	return current;
	// };

	const getByPath = (
		obj: any,
		path: string
	) => {
		const dotIndex = path.indexOf(".");

		if (dotIndex === -1) {
			return obj?.[path];
		}

		const parent = path.substring(0, dotIndex);
		const key = path.substring(dotIndex + 1);

		return obj?.[parent]?.[key];
	};


	const vocationalEarningsListRef = useRef(vocationalEarningsList);
	vocationalEarningsListRef.current = vocationalEarningsList;
	const selectedPayPeriodRef = useRef(selectedPayPeriod);
	selectedPayPeriodRef.current = selectedPayPeriod;
	const onSnackbarMessageDataRef = useRef(onSnackbarMessageData);
	onSnackbarMessageDataRef.current = onSnackbarMessageData;
	const showChecboxColumnRef = useRef(showChecboxColumn);
	showChecboxColumnRef.current = showChecboxColumn;
	const enableFrozenColumnsRef = useRef(enableFrozenColumns);
	enableFrozenColumnsRef.current = enableFrozenColumns;




	const onCellValueChange = useCallback((column: any, rowIndex: number, value: any, rowData: any) => {
		// const getByPath = (obj: any, path: string) =>
		// 	path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);

		if (showChecboxColumnRef.current && rowData) {
			const allVocationableEarningsListOfThisEmployeeProvince = [
				...(vocationalEarningsListRef.current.vocationableEarnings[rowData.provinceId] ?? []),
				...vocationalEarningsListRef.current.edr.map((label: string) => `customAmounts.${label}`)
			];
			if (allVocationableEarningsListOfThisEmployeeProvince && allVocationableEarningsListOfThisEmployeeProvince.length > 0) {
				if (
					column.field === 'grossIncome' && value && value !== null && value !== 0
				) {
					const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);

					setPayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };
						setValueByFieldPath(updatedRow, column.field, value);
						if (isVocationable) {
							let totalSum = 0;
							const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
							allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
								if (notAllowedFields.includes(vocField)) return;
								const fieldValue =
									vocField === column.field
										? Number(value) || 0
										: Number(getByPath(updatedRow, vocField)) || 0;
								totalSum += fieldValue;
							});
							const calculatedValue = (totalSum * updatedRow.minVocationPayOfGross) / 100;
							if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
								// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
								const initialRowValue =
									originalPayrollMap.get(rowData.employeeId);

								console.log('initialRowValue', initialRowValue)
								const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
								const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
								const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
								const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
								if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
									let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
									updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
									updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
								}
								if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
									updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
								}
							} else {
								const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0;
								let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
								if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
									// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
									updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
									updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
								}
								if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
									updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
								}
							}
						}
						updatedData[rowIndex] = updatedRow;
						// const rowMap = new Map(
						// 	updatedData.map(row => [
						// 		row.employeeId,
						// 		row
						// 	])
						// );
						// setSelectedItems((prev: any) =>
						// 	prev
						// 		.map((item: any) => rowMap.get(item.employeeId))
						// 		.filter(Boolean)
						// );
						// setSelectedItems((prevSelected: any[]) =>
						// 	prevSelected
						// 		.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
						// 		.filter(Boolean)
						// );
						setSelectedItems((prev: any[]) => {
							if (!prev.length) return prev;

							const updatedEmployeeId =
								updatedRow.employeeId;

							return prev.map((item) =>
								item.employeeId === updatedEmployeeId
									? updatedRow
									: item
							);
						});
						return updatedData;
					});
				} else if (
					(column.field === 'grossIncome') && (!value || value === null || value === 0)
				) {
					const allowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
					// const isVocationable = allowedFields.some(field =>
					// 	allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					// );
					const matchedFields = allowedFields.filter(field =>
						allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					);
					const matchedCount = matchedFields.length;
					const hasRegular = matchedFields.includes("regularHours");
					const hasOt1 = matchedFields.includes("ot1Dot5Hours");
					const hasOt2 = matchedFields.includes("ot2Dot0Hours");
					const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);
					setPayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };
						setValueByFieldPath(updatedRow, column.field, value);
						if (isVocationable) {
							let totalSum = 0;
							const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
							allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
								if (notAllowedFields.includes(vocField)) return;
								const fieldValue =
									vocField === column.field
										? Number(value) || 0
										: Number(getByPath(updatedRow, vocField)) || 0;

								totalSum += fieldValue;
							});
							const regularHoursValue = hasRegular &&
								Number(updatedRow.regularHours || 0) *
								Number(updatedRow.hourlyRate || 0);
							const ot1Dot5HoursValue = hasOt1 &&
								Number(updatedRow.ot1Dot5Hours || 0) *
								Number(updatedRow.hourlyRate || 0) * 1.5;
							const ot2Dot0HoursValue = hasOt2 &&
								Number(updatedRow.ot2Dot0Hours || 0) *
								Number(updatedRow.hourlyRate || 0) * 2.0;
							let grossValue = (regularHoursValue || 0) + (ot1Dot5HoursValue || 0) + (ot2Dot0HoursValue || 0) + totalSum
							const calculatedValue = (grossValue * updatedRow.minVocationPayOfGross) / 100;
							if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
								// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
								const initialRowValue =
									originalPayrollMap.get(rowData.employeeId);
								const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
								const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
								const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
								const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
								if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
									let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
									updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
									updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
								}
								if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
									updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
								}
							} else {
								const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
								if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
									let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
									// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
									updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
									updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
								}
								if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
									updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
								}

							}
						}
						updatedData[rowIndex] = updatedRow;
						// const rowMap = new Map(
						// 	updatedData.map(row => [
						// 		row.employeeId,
						// 		row
						// 	])
						// );
						// setSelectedItems((prev: any) =>
						// 	prev
						// 		.map((item: any) => rowMap.get(item.employeeId))
						// 		.filter(Boolean)
						// );
						// setSelectedItems((prevSelected: any[]) =>
						// 	prevSelected
						// 		.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
						// 		.filter(Boolean)
						// );
						setSelectedItems((prev: any[]) => {
							if (!prev.length) return prev;

							const updatedEmployeeId =
								updatedRow.employeeId;

							return prev.map((item) =>
								item.employeeId === updatedEmployeeId
									? updatedRow
									: item
							);
						});
						return updatedData;
					});

				} else if (column.field === 'regularHours' || column.field === 'ot1Dot5Hours' || column.field === 'ot2Dot0Hours') {
					const allowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
					// const isVocationable = allowedFields.some(field =>
					// 	allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					// );
					const matchedFields = allowedFields.filter(field =>
						allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					);
					const matchedCount = matchedFields.length;
					const hasRegular = matchedFields.includes("regularHours");
					const hasOt1 = matchedFields.includes("ot1Dot5Hours");
					const hasOt2 = matchedFields.includes("ot2Dot0Hours");
					// const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);
					const isVocationable = matchedCount > 0;
					setPayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };
						setValueByFieldPath(updatedRow, column.field, value);
						const regularHours = column.field === 'regularHours' ? Number(value) : Number(rowData.regularHours || 0);
						const ot1Dot5 = column.field === 'ot1Dot5Hours' ? Number(value) : Number(rowData.ot1Dot5Hours || 0);
						const ot2Dot0 = column.field === 'ot2Dot0Hours' ? Number(value) : Number(rowData.ot2Dot0Hours || 0);
						const total = regularHours + ot1Dot5 + ot2Dot0;
						const cellKey = `${rowData.employeeId}-${column.field}`;
						const withinLimit = validateHoursLimit(column.field, total, updatedRow, selectedPayPeriodRef.current, onSnackbarMessageDataRef.current, cellKey);
						if (
							withinLimit &&
							isVocationable &&
							(
								!updatedRow.grossIncome ||
								updatedRow.grossIncome === null ||
								updatedRow.grossIncome === "" ||
								updatedRow.grossIncome === "0.00" ||
								Number(updatedRow.grossIncome) === 0
							)
						) {
							if (column.field === 'regularHours') {
								// const regularHours = Number(value);
								// const ot1Dot5 = Number(updatedRow.ot1Dot5Hours || 0)
								// const ot2Dot0 = Number(updatedRow.ot2Dot0Hours || 0)
								// const total = regularHours + ot1Dot5 + ot2Dot0;
								// if (selectedPayPeriod && selectedPayPeriod.payPeriodCode === 12 && total > 744) {
								// 	onSnackbarMessageData && onSnackbarMessageData({
								// 		open: true,
								// 		message: "Sum of all hours cannot be greater than 744 for this Pay Period",
								// 		severity: "error"
								// 	})
								// 	updatedRow["regularHours"] = "0.00";
								// } else if (selectedPayPeriod && selectedPayPeriod.payPeriodCode === 26 && total > 336) {
								// 	onSnackbarMessageData && onSnackbarMessageData({
								// 		open: true,
								// 		message: "Sum of all hours cannot be greater than 336 for this Pay Period",
								// 		severity: "error"
								// 	})
								// 	updatedRow["regularHours"] = "0.00";
								// } else if (selectedPayPeriod && selectedPayPeriod.payPeriodCode === 52 && total > 168) {
								// 	onSnackbarMessageData && onSnackbarMessageData({
								// 		open: true,
								// 		message: "Sum of all hours cannot be greater than 168 for this Pay Period",
								// 		severity: "error"
								// 	})
								// 	updatedRow["regularHours"] = "0.00";
								// } else if (selectedPayPeriod && selectedPayPeriod.payPeriodCode === 24 && total > 384) {
								// 	onSnackbarMessageData && onSnackbarMessageData({
								// 		open: true,
								// 		message: "Sum of all hours cannot be greater than 384 for this Pay Period",
								// 		severity: "error"
								// 	})
								// 	updatedRow["regularHours"] = "0.00";
								// }
								// const withinLimit = validateHoursLimit('regularHours', total, updatedRow, selectedPayPeriod, onSnackbarMessageData);
								// if (withinLimit) {
								let totalSum = 0;
								const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
								allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
									if (notAllowedFields.includes(vocField)) return;
									const fieldValue =
										vocField === column.field
											? Number(value) || 0
											: Number(getByPath(updatedRow, vocField)) || 0;

									totalSum += fieldValue;
								});
								const ot1Dot5HoursValue =
									Number(updatedRow.ot1Dot5Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 1.5;
								const ot2Dot0HoursValue =
									Number(updatedRow.ot2Dot0Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 2.0;
								let grossValue = value * Number(updatedRow.hourlyRate || 0) + ot1Dot5HoursValue + ot2Dot0HoursValue + totalSum
								const calculatedValue = (grossValue * updatedRow.minVocationPayOfGross) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
									const initialRowValue =
										originalPayrollMap.get(rowData.employeeId);
									const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
									const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
									const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
									const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
										updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
									}
								} else {
									const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
										updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
									}
								}
								// }
							} else if (column.field === 'ot1Dot5Hours') {
								// const regularHours = Number(updatedRow.regularHours || 0);
								// const ot1Dot5 = Number(value);
								// const ot2Dot0 = Number(updatedRow.ot2Dot0Hours || 0);
								// const total = regularHours + ot1Dot5 + ot2Dot0;

								// const withinLimit = validateHoursLimit('ot1Dot5Hours', total, updatedRow, selectedPayPeriod, onSnackbarMessageData);
								// if (withinLimit) {
								let totalSum = 0;
								const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
								allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
									if (notAllowedFields.includes(vocField)) return;
									const fieldValue =
										vocField === column.field
											? Number(value) || 0
											: Number(getByPath(updatedRow, vocField)) || 0;

									totalSum += fieldValue;
								});
								const regularHoursValue =
									Number(updatedRow.regularHours || 0) *
									Number(updatedRow.hourlyRate || 0);
								const ot2Dot0HoursValue =
									Number(updatedRow.ot2Dot0Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 2.0;
								let grossValue = (value * updatedRow.hourlyRate * 1.5) + regularHoursValue + ot2Dot0HoursValue + totalSum
								const calculatedValue = (grossValue * updatedRow.minVocationPayOfGross) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
									const initialRowValue =
										originalPayrollMap.get(rowData.employeeId);
									const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
									const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
									const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
									const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
										updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
									}
								} else {
									const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
										updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
									}
								}
								// }
							} else if (column.field === 'ot2Dot0Hours') {
								// const regularHours = Number(updatedRow.regularHours || 0);
								// const ot1Dot5 = Number(updatedRow.ot1Dot5Hours || 0);
								// const ot2Dot0 = Number(value);
								// const total = regularHours + ot1Dot5 + ot2Dot0;

								// const withinLimit = validateHoursLimit('ot2Dot0Hours', total, updatedRow, selectedPayPeriod, onSnackbarMessageData);
								// if (withinLimit) {
								let totalSum = 0;
								const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
								allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
									if (notAllowedFields.includes(vocField)) return;
									const fieldValue =
										vocField === column.field
											? Number(value) || 0
											: Number(getByPath(updatedRow, vocField)) || 0;

									totalSum += fieldValue;
								});
								const regularHoursValue =
									Number(updatedRow.regularHours || 0) *
									Number(updatedRow.hourlyRate || 0);
								const ot1Dot5HoursValue =
									Number(updatedRow.ot1Dot5Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 1.5;
								let grossValue = (value * updatedRow.hourlyRate * 2.0) + regularHoursValue + ot1Dot5HoursValue + totalSum
								const calculatedValue = (grossValue * updatedRow.minVocationPayOfGross) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
									const initialRowValue =
										originalPayrollMap.get(rowData.employeeId);
									const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
									const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
									const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
									const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
										updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
									}
								} else {
									const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
										updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
									}
								}
								// }
							}
						}
						updatedData[rowIndex] = updatedRow;
						// const rowMap = new Map(
						// 	updatedData.map(row => [
						// 		row.employeeId,
						// 		row
						// 	])
						// );
						// setSelectedItems((prev: any) =>
						// 	prev
						// 		.map((item: any) => rowMap.get(item.employeeId))
						// 		.filter(Boolean)
						// );
						// setSelectedItems((prevSelected: any[]) =>
						// 	prevSelected
						// 		.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
						// 		.filter(Boolean)
						// );
						setSelectedItems((prev: any[]) => {
							if (!prev.length) return prev;

							const updatedEmployeeId =
								updatedRow.employeeId;

							return prev.map((item) =>
								item.employeeId === updatedEmployeeId
									? updatedRow
									: item
							);
						});
						return updatedData;
					});

				} else {
					if (
						rowData.grossIncome && rowData.grossIncome !== null && rowData.grossIncome !== 0
					) {
						const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);
						setPayrollItems((prev: any[]) => {
							const updatedData = [...prev];
							const updatedRow = { ...updatedData[rowIndex] };
							setValueByFieldPath(updatedRow, column.field, value);
							if (isVocationable) {
								let totalSum = 0;
								const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
								allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
									if (notAllowedFields.includes(vocField)) return;
									const getByPath = (obj: any, path: string) =>
										path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
									const fieldValue =
										vocField === column.field
											? Number(value) || 0
											: Number(getByPath(updatedRow, vocField)) || 0;
									totalSum += fieldValue;
								});
								const calculatedValue = (totalSum * updatedRow.minVocationPayOfGross) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
									const initialRowValue =
										originalPayrollMap.get(rowData.employeeId);
									const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
									const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
									const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
									const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;

									// console.log('initialRowValue', initialRowValue)
									// console.log('previousSavedVacDue', previousSavedVacDue)
									// console.log('previousPeriodVacDue', previousPeriodVacDue)
									// console.log('savedVacationPay', savedVacationPay)
									// console.log('calculatedValue', calculatedValue)
									// console.log('newValue', newValue)
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
										updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
									}
								} else {
									const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
										updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
									}
								}
							}
							updatedData[rowIndex] = updatedRow;
							// const rowMap = new Map(
							// 	updatedData.map(row => [
							// 		row.employeeId,
							// 		row
							// 	])
							// );
							// setSelectedItems((prev: any) =>
							// 	prev
							// 		.map((item: any) => rowMap.get(item.employeeId))
							// 		.filter(Boolean)
							// );
							// setSelectedItems((prevSelected: any[]) =>
							// 	prevSelected
							// 		.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
							// 		.filter(Boolean)
							// );
							setSelectedItems((prev: any[]) => {
								if (!prev.length) return prev;

								const updatedEmployeeId =
									updatedRow.employeeId;

								return prev.map((item) =>
									item.employeeId === updatedEmployeeId
										? updatedRow
										: item
								);
							});
							return updatedData;
						});
					} else if (
						!rowData.grossIncome || rowData.grossIncome === null || rowData.grossIncome === 0
					) {
						const allowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
						// const isVocationable = allowedFields.some(field =>
						// 	allVocationableEarningsListOfThisEmployeeProvince.includes(field)
						// );
						const matchedFields = allowedFields.filter(field =>
							allVocationableEarningsListOfThisEmployeeProvince.includes(field)
						);
						const matchedCount = matchedFields.length;
						const hasRegular = matchedFields.includes("regularHours");
						const hasOt1 = matchedFields.includes("ot1Dot5Hours");
						const hasOt2 = matchedFields.includes("ot2Dot0Hours");
						const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);
						setPayrollItems((prev: any[]) => {
							const updatedData = [...prev];
							const updatedRow = { ...updatedData[rowIndex] };
							setValueByFieldPath(updatedRow, column.field, value);
							if (isVocationable) {
								let totalSum = 0;
								const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
								allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
									if (notAllowedFields.includes(vocField)) return;
									const fieldValue =
										vocField === column.field
											? Number(value) || 0
											: Number(getByPath(updatedRow, vocField)) || 0;
									totalSum += fieldValue;
								});
								const regularHoursValue = hasRegular &&
									Number(updatedRow.regularHours || 0) *
									Number(updatedRow.hourlyRate || 0);
								const ot1Dot5HoursValue = hasOt1 &&
									Number(updatedRow.ot1Dot5Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 1.5;
								const ot2Dot0HoursValue = hasOt2 &&
									Number(updatedRow.ot2Dot0Hours || 0) *
									Number(updatedRow.hourlyRate || 0) * 2.0;
								let grossValue = (regularHoursValue || 0) + (ot1Dot5HoursValue || 0) + (ot2Dot0HoursValue || 0) + totalSum
								const calculatedValue = (grossValue * updatedRow.minVocationPayOfGross) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// const initialRowValue = originalPayrollDataItems && originalPayrollDataItems.find((x: any) => x.employeeId === rowData.employeeId)
									const initialRowValue =
										originalPayrollMap.get(rowData.employeeId);
									const previousSavedVacDue = Number(initialRowValue.vacationPayAccured) || 0;
									const previousPeriodVacDue = Number(initialRowValue.vacationPayAccuredTotal) || 0;
									const savedVacationPay = Number(initialRowValue.vacationPay) || 0;
									const newValue = savedVacationPay + previousPeriodVacDue + calculatedValue - previousSavedVacDue;
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = newValue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(Math.round(latestValue * 100) / 100);
										updatedRow["vacationPayAccuredCalculated"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(Math.round(newValue * 100) / 100);
									}
								} else {
									const previousPeriodVacDue = updatedRow.vacationPayAccuredTotal ? Number(updatedRow.vacationPayAccuredTotal) : 0
									if (updatedRow["vacationPayFlag"] && updatedRow["vacationPayFlag"] === 100) {
										let latestValue = previousPeriodVacDue + Number(updatedRow["vacationPayOpenBalance"]) || 0;
										// updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue);
										updatedRow["vacationPayAccured"] = formatAmountCommaSeperator(latestValue + calculatedValue);
										updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = formatAmountCommaSeperator(Math.round(calculatedValue * 100) / 100);
									}
									if (updatedRow["payOutVacationPayFlag"] && updatedRow["payOutVacationPayFlag"] === 200) {
										updatedRow["vacationPay"] = formatAmountCommaSeperator(previousPeriodVacDue);
									}
								}
							}
							updatedData[rowIndex] = updatedRow;
							// const rowMap = new Map(
							// 	updatedData.map(row => [
							// 		row.employeeId,
							// 		row
							// 	])
							// );
							// setSelectedItems((prev: any) =>
							// 	prev
							// 		.map((item: any) => rowMap.get(item.employeeId))
							// 		.filter(Boolean)
							// );
							// setSelectedItems((prevSelected: any[]) =>
							// 	prevSelected
							// 		.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
							// 		.filter(Boolean)
							// );
							setSelectedItems((prev: any[]) => {
								if (!prev.length) return prev;

								const updatedEmployeeId =
									updatedRow.employeeId;

								return prev.map((item) =>
									item.employeeId === updatedEmployeeId
										? updatedRow
										: item
								);
							});
							return updatedData;
						});

					}
				}
			} else {
				setPayrollItems((prev: any[]) => {
					const updatedData = [...prev];
					const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
					updatedData[rowIndex] = updatedRow;
					// const rowMap = new Map(
					// 	updatedData.map(row => [
					// 		row.employeeId,
					// 		row
					// 	])
					// );
					// setSelectedItems((prev: any) =>
					// 	prev
					// 		.map((item: any) => rowMap.get(item.employeeId))
					// 		.filter(Boolean)
					// );
					// setSelectedItems((prevSelected: any[]) =>
					// 	prevSelected
					// 		.map(sel => updatedData.find(r => r.employeeId === sel.employeeId))
					// 		.filter(Boolean)
					// );
					setSelectedItems((prev: any[]) => {
						if (!prev.length) return prev;

						const updatedEmployeeId =
							updatedRow.employeeId;

						return prev.map((item) =>
							item.employeeId === updatedEmployeeId
								? updatedRow
								: item
						);
					});
					return updatedData;
				});
			}
		} else {
			setPayrollItems((prev: any[]) => {
				const updatedData = [...prev];
				const updatedRow = updatedData[rowIndex];
				setValueByFieldPath(updatedRow, column.field, value);
				return updatedData;
			});
		}
		// }, [vocationalEarningsListRef.current, selectedPayPeriodRef.current, onSnackbarMessageDataRef.current]);
	}, []);

	const onEmployeeNameClickedHandler = (rowData: any) => {
		if (rowData.salaryProfileMessage) navigate(`/employee/salary-profile/z_${rowData.employeeId}`);
		// if(!rowData.salaryProfileMessage) navigate('');
		if (!rowData.salaryProfileMessage) alert("comming soon...");
	}
	const onSequenceNumberClickedHandler = (rowData: any) => {
		alert("comming soon...")
	}
	const inputRefs = useRef<Record<string, HTMLInputElement | null>>({});

	const setInputRef = useCallback(
		(
			cellKey: string,
			element: HTMLInputElement | null
		) => {
			if (element) {
				inputRefs.current[cellKey] =
					element;
			} else {
				delete inputRefs.current[
					cellKey
				];
			}
		},
		[]
	);

	const editableNumberColumns = useMemo(
		() =>
			sortedColumns.filter(
				(col: any) =>
					col.isEditable &&
					col.type === "number"
			),
		[sortedColumns]
	);

	const editableNumberColumnsRef = useRef(editableNumberColumns);
	editableNumberColumnsRef.current = editableNumberColumns;

	// const handleCellNavigation = (
	// 	e: React.KeyboardEvent<HTMLInputElement>,
	// 	rowIndex: number,
	// 	column: any
	// ) => {
	// 	const navigationKeys = [
	// 		"ArrowUp",
	// 		"ArrowDown",
	// 		"ArrowLeft",
	// 		"ArrowRight"
	// 	];

	// 	if (!navigationKeys.includes(e.key)) {
	// 		return;
	// 	}

	// 	e.preventDefault();

	// 	const editableColumns = columns.filter(
	// 		(col: any) => col.isEditable && col.type === "number"
	// 	);

	// 	const currentColumnIndex = editableColumns.findIndex(
	// 		(col: any) => col.field === column.field
	// 	);

	// 	if (currentColumnIndex === -1) {
	// 		return;
	// 	}

	// 	let targetRowIndex = rowIndex;
	// 	let targetColumnIndex = currentColumnIndex;

	// 	switch (e.key) {
	// 		case "ArrowUp":
	// 			targetRowIndex = rowIndex - 1;
	// 			break;

	// 		case "ArrowDown":
	// 			targetRowIndex = rowIndex + 1;
	// 			break;

	// 		case "ArrowLeft":
	// 			targetColumnIndex = currentColumnIndex - 1;
	// 			break;

	// 		case "ArrowRight":
	// 			targetColumnIndex = currentColumnIndex + 1;
	// 			break;
	// 	}
	// 	if (
	// 		targetRowIndex < 0 ||
	// 		targetRowIndex >= payrollItems.length ||
	// 		targetColumnIndex < 0 ||
	// 		targetColumnIndex >= editableColumns.length
	// 	) {
	// 		return;
	// 	}

	// 	const targetColumn = editableColumns[targetColumnIndex];
	// 	const targetRow = payrollItems[targetRowIndex];

	// 	if (!targetColumn || !targetRow) {
	// 		return;
	// 	}

	// 	const targetCellKey =
	// 		`${targetRow.employeeId}-${targetColumn.field}`;

	// 	const targetInput =
	// 		inputRefs.current[targetCellKey];

	// 	if (targetInput) {
	// 		targetInput.focus();

	// 		requestAnimationFrame(() => {
	// 			const inputValue = targetInput.value;

	// 			// Cursor before decimal point
	// 			const decimalIndex = inputValue.indexOf(".");

	// 			const cursorPosition =
	// 				decimalIndex >= 0
	// 					? decimalIndex
	// 					: inputValue.length;

	// 			targetInput.setSelectionRange(
	// 				cursorPosition,
	// 				cursorPosition
	// 			);
	// 		});
	// 	}
	// };

	// const handleCellNavigation = useCallback(
	// 	(
	// 		e: React.KeyboardEvent<HTMLInputElement>,
	// 		rowIndex: number,
	// 		column: any
	// 	) => {
	// 		const key = e.key;

	// 		if (
	// 			key !== "ArrowUp" &&
	// 			key !== "ArrowDown" &&
	// 			key !== "ArrowLeft" &&
	// 			key !== "ArrowRight"
	// 		) {
	// 			return;
	// 		}

	// 		e.preventDefault();

	// 		const currentColumnIndex =
	// 			editableNumberColumnsRef.current.findIndex(
	// 				(col: any) => col.field === column.field
	// 			);

	// 		if (currentColumnIndex === -1) {
	// 			return;
	// 		}

	// 		let targetRowIndex = rowIndex;
	// 		let targetColumnIndex = currentColumnIndex;

	// 		if (key === "ArrowUp") {
	// 			targetRowIndex--;
	// 		} else if (key === "ArrowDown") {
	// 			targetRowIndex++;
	// 		} else if (key === "ArrowLeft") {
	// 			targetColumnIndex--;
	// 		} else if (key === "ArrowRight") {
	// 			targetColumnIndex++;
	// 		}

	// 		if (
	// 			targetRowIndex < 0 ||
	// 			targetRowIndex >= payrollItemsRef.current.length ||
	// 			targetColumnIndex < 0 ||
	// 			targetColumnIndex >= editableNumberColumnsRef.current.length
	// 		) {
	// 			return;
	// 		}

	// 		const targetColumn =
	// 			editableNumberColumnsRef.current[targetColumnIndex];

	// 		const targetRow =
	// 			payrollItemsRef.current[targetRowIndex];

	// 		if (!targetColumn || !targetRow) {
	// 			return;
	// 		}

	// 		const targetCellKey =
	// 			`${targetRow.employeeId}-${targetColumn.field}`;

	// 		const targetInput =
	// 			inputRefs.current[targetCellKey];

	// 		if (!targetInput) {
	// 			return;
	// 		}

	// 		targetInput.focus();

	// 		requestAnimationFrame(() => {
	// 			const inputValue = targetInput.value;

	// 			const decimalIndex =
	// 				inputValue.indexOf(".");

	// 			const cursorPosition =
	// 				decimalIndex >= 0
	// 					? decimalIndex
	// 					: inputValue.length;

	// 			targetInput.setSelectionRange(
	// 				cursorPosition,
	// 				cursorPosition
	// 			);
	// 		});
	// 	},
	// 	// [editableNumberColumnsRef.current, payrollItemsRef.current]
	// 	[]
	// );


	// FOR DIV TAG NUMBER CELL
	const handleCellNavigation = useCallback(
		(e: React.KeyboardEvent<any>, rowIndex: number, column: any) => {
			const key = e.key;
			if (key !== "ArrowUp" && key !== "ArrowDown" && key !== "ArrowLeft" && key !== "ArrowRight") return;
			e.preventDefault();

			const currentColumnIndex = editableNumberColumnsRef.current.findIndex(
				(col: any) => col.field === column.field
			);
			if (currentColumnIndex === -1) return;

			let targetRowIndex = rowIndex;
			let targetColumnIndex = currentColumnIndex;

			if (key === "ArrowUp") targetRowIndex--;
			else if (key === "ArrowDown") targetRowIndex++;
			else if (key === "ArrowLeft") targetColumnIndex--;
			else if (key === "ArrowRight") targetColumnIndex++;

			if (
				targetRowIndex < 0 ||
				targetRowIndex >= payrollItemsRef.current.length ||
				targetColumnIndex < 0 ||
				targetColumnIndex >= editableNumberColumnsRef.current.length
			) return;

			const targetColumn = editableNumberColumnsRef.current[targetColumnIndex];
			const targetRow = payrollItemsRef.current[targetRowIndex];
			if (!targetColumn || !targetRow) return;

			const targetCellKey = `${targetRow.employeeId}-${targetColumn.field}`;
			const targetEl = inputRefs.current[targetCellKey];
			if (!targetEl) return;

			targetEl.focus();

			requestAnimationFrame(() => {
				// CHANGED: branch by element type instead of assuming .value/.setSelectionRange
				if (targetEl instanceof HTMLInputElement) {
					const inputValue = targetEl.value;
					const decimalIndex = inputValue.indexOf(".");
					const cursorPosition = decimalIndex >= 0 ? decimalIndex : inputValue.length;
					targetEl.setSelectionRange(cursorPosition, cursorPosition);
				} else {
					placeCaretBeforeDecimal(targetEl);
				}
			});
		},
		[]
	);

	// 	const focusCell = useCallback(
	//     (rowIndex: number, column: any) => {
	//         const targetRow = payrollItems[rowIndex];

	//         if (!targetRow) return;

	//         const targetCellKey =
	//             `${targetRow.employeeId}-${column.field}`;

	//         const input =
	//             inputRefs.current[targetCellKey];

	//         if (input) {
	//             input.focus();

	//             requestAnimationFrame(() => {
	//                 const value = input.value;
	//                 const decimalIndex = value.indexOf(".");

	//                 const cursorPosition =
	//                     decimalIndex >= 0
	//                         ? decimalIndex
	//                         : value.length;

	//                 input.setSelectionRange(
	//                     cursorPosition,
	//                     cursorPosition
	//                 );
	//             });

	//             return;
	//         }

	//         // Virtualized row isn't mounted yet.
	//         // Scroll to row and focus after PrimeReact renders it.
	//         virtualScrollerRef.current?.scrollToIndex(rowIndex);

	//         requestAnimationFrame(() => {
	//             requestAnimationFrame(() => {
	//                 const targetInput =
	//                     inputRefs.current[targetCellKey];

	//                 targetInput?.focus();
	//             });
	//         });
	//     },
	//     [payrollItems]
	// );
	const getNumberFieldClass = (column: any) => {
		if (column.field === "vacationPay") {
			return "vacationPayField";
		}

		if (
			column.field === "holidayHours" ||
			column.field === "holidayPay" ||
			column.field === "holidayPayAccured"
		) {
			return "holidayHoursField";
		}

		if (column.edr === "earnings") {
			return "earningsField";
		}

		if (column.edr === "deductions") {
			return "deductionsField";
		}

		if (column.edr === "reimbursements") {
			return "reimbursementsField";
		}

		return "";
	};
	// const PayrollNumberCell = React.memo(
	// 	({
	// 		value,
	// 		cellKey,
	// 		column,
	// 		rowIndex,
	// 		rowData,
	// 		onCellValueChange,
	// 		setActiveRowIndex,
	// 		inputRefs,
	// 		handleCellNavigation,
	// 	}: any) => {

	// 		return (
	// 			<InputNumber
	// 				value={value}
	// 				minFractionDigits={2}
	// 				maxFractionDigits={2}
	// 				inputClassName={getNumberFieldClass(column)}
	// 				inputStyle={{
	// 					textAlign: "right"
	// 				}}
	// 				inputRef={(el) => {
	// 					inputRefs.current[cellKey] = el;
	// 				}}
	// 				onFocus={() =>
	// 					setActiveRowIndex(
	// 						rowData.employeeId
	// 					)
	// 				}
	// 				onBlur={() => {
	// 					const raw =
	// 						inputRefs.current[
	// 							cellKey
	// 						]?.value;

	// 					const edited =
	// 						raw === "" || raw == null
	// 							? null
	// 							: Number(
	// 								raw.replace(
	// 									/,/g,
	// 									""
	// 								)
	// 							);

	// 					onCellValueChange(
	// 						column,
	// 						rowIndex,
	// 						edited,
	// 						rowData
	// 					);
	// 				}}
	// 				onKeyDown={(e) =>
	// 					handleCellNavigation(
	// 						e,
	// 						rowIndex,
	// 						column
	// 					)
	// 				}
	// 			/>
	// 		);
	// 	}
	// );

	const getCellValue = (
		rowData: any,
		field: string
	) => {
		if (field.indexOf(".") === -1) {
			return rowData[field];
		}

		return getValueByFieldPath(
			rowData,
			field
		);
	};

	const getColumnClassName = (
		x: any
	) => {
		if (
			x.field === "vacationPay" ||
			x.field ===
			"vacationPayAccured"
		) {
			return "vacationPayField";
		}

		if (
			x.field === "holidayHours" ||
			x.field ===
			"holidayPayAccured" ||
			x.field === "holidayPay"
		) {
			return "holidayHoursField";
		}

		if (x.edr === "earnings") {
			return "earningsField";
		}

		if (x.edr === "deductions") {
			return "deductionsField";
		}

		if (
			x.edr === "reimbursements"
		) {
			return "reimbursementsField";
		}

		return "";
	};

	const columnMeta = useMemo(() => {
		return sortedColumns.map(
			(column: any) => ({
				...column,
				cellClassName:
					getColumnClassName(
						column
					),
				numberClassName:
					getNumberFieldClass(
						column
					),
			})
		);
	}, [sortedColumns]);

	const columnMetaMap = useMemo(() => {
		const map = new Map<string, any>();

		for (const column of columnMeta) {
			map.set(column.field, column);
		}

		return map;
	}, [columnMeta]);

	// const handleGridFocus = useCallback(
	// 	(event: React.FocusEvent<HTMLDivElement>) => {
	// 		// const target = event.target as HTMLInputElement;

	// 		// if (!target.dataset.payrollInput) {
	// 		// 	return;
	// 		// }

	// 		// setActiveRowIndex(
	// 		// 	Number(target.dataset.employeeId)
	// 		// );
	// 	},
	// 	[]
	// );

	// const handleGridFocus = useCallback(
	// 	(event: React.FocusEvent<HTMLDivElement>) => {
	// 		const target = event.target as HTMLInputElement;
	// 		if (!target.dataset.payrollInput) return;
	// 		activeRowRef.current = Number(target.dataset.employeeId);
	// 	},
	// 	[]
	// );

	const handleGridFocus = useCallback(
		(event: React.FocusEvent<HTMLDivElement>) => {
			const target = event.target as HTMLInputElement;

			if (!target.dataset.payrollInput) {
				return;
			}

			const employeeId = target.dataset.employeeId;

			if (!employeeId) return;

			const container = containerRef.current;

			if (!container) return;

			// // Remove previous row highlight
			// container
			// 	.querySelectorAll(".highlighted-row")
			// 	.forEach((row) => {
			// 		row.classList.remove("highlighted-row");
			// 	});

			// // Find all inputs belonging to this employee
			// container
			// 	.querySelectorAll(
			// 		`input[data-payroll-input="true"][data-employee-id="${employeeId}"]`
			// 	)
			// 	.forEach((input) => {
			// 		const row = input.closest("tr");

			// 		if (row) {
			// 			row.classList.add("highlighted-row");
			// 		}
			// 	});


			container.querySelectorAll(".highlighted-row").forEach((row) => {
				row.classList.remove("highlighted-row");
			});

			// CHANGED: removed the leading "input" tag restriction —
			// now matches both <input> and <div contentEditable>
			container
				.querySelectorAll(`[data-payroll-input="true"][data-employee-id="${employeeId}"]`)
				.forEach((cell) => {
					const row = cell.closest("tr");
					if (row) row.classList.add("highlighted-row");
				});
		},
		[]
	);


	// const handleGridBlur = useCallback(
	// 	(event: React.FocusEvent<HTMLDivElement>) => {
	// 		const target = event.target as HTMLInputElement;

	// 		if (!target.dataset.payrollInput) {
	// 			return;
	// 		}

	// 		const rowIndex = Number(target.dataset.rowIndex);
	// 		const field = target.dataset.field;

	// 		if (!field || Number.isNaN(rowIndex)) {
	// 			return;
	// 		}

	// 		const raw = target.value;

	// 		const value =
	// 			raw.trim() === ""
	// 				? null
	// 				: Number(raw.replace(/,/g, ""));

	// 		const column = columnMetaMap.get(field);

	// 		if (!column) {
	// 			return;
	// 		}

	// 		const rowData =
	// 			payrollItemsRef.current[rowIndex];

	// 		if (!rowData) {
	// 			return;
	// 		}

	// 		onCellValueChange(
	// 			column,
	// 			rowIndex,
	// 			Number.isNaN(value as number)
	// 				? null
	// 				: value,
	// 			rowData
	// 		);
	// 	},
	// 	[
	// 		columnMetaMap,
	// 		onCellValueChange
	// 	]
	// );

	// const handleGridBlur = useCallback(
	// 	(event: React.FocusEvent<HTMLDivElement>) => {
	// 		const target = event.target as HTMLInputElement;
	// 		if (!target.dataset.payrollInput) return;

	// 		const rowIndex = Number(target.dataset.rowIndex);
	// 		const field = target.dataset.field;
	// 		if (!field || Number.isNaN(rowIndex)) return;

	// 		const raw = target.value;
	// 		const value =
	// 			raw.trim() === ""
	// 				? null
	// 				: Number(raw.replace(/,/g, ""));

	// 		const column = columnMetaMap.get(field);
	// 		if (!column) return;

	// 		const rowData = payrollItemsRef.current[rowIndex];
	// 		if (!rowData) return;

	// 		// Only skip if field is empty AND data is already empty
	// 		const currentValue = getCellValue(rowData, field);
	// 		const currentIsEmpty =
	// 			currentValue === null ||
	// 			currentValue === undefined ||
	// 			currentValue === "";

	// 		if (value === null && currentIsEmpty) {
	// 			return;
	// 		}

	// 		onCellValueChange(
	// 			column,
	// 			rowIndex,
	// 			Number.isNaN(value as number) ? null : value,
	// 			rowData
	// 		);
	// 	},
	// 	[columnMetaMap, onCellValueChange]
	// );



	// is may onchange call hota ha 
	const handleGridBlur = useCallback(
		(event: React.FocusEvent<HTMLDivElement>) => {
			const target = event.target as HTMLInputElement;

			if (!target.dataset.payrollInput) {
				return;
			}

			const rowIndex = Number(target.dataset.rowIndex);
			const field = target.dataset.field;

			if (!field) {
				return;
			}

			const raw = target.textContent.trim();

			// Empty input
			if (raw === "") {
				target.textContent = "";

				const column = columnMeta.find(
					(item: any) => item.field === field
				);

				if (!column) return;

				onCellValueChange(
					column,
					rowIndex,
					null,
					payrollItems[rowIndex]
				);

				return;
			}

			const numericValue = Number(
				raw.replace(/,/g, "")
			);

			if (Number.isNaN(numericValue)) {
				return;
			}

			// minFractionDigits={2}
			// maxFractionDigits={2}
			const formattedValue = numericValue.toFixed(2);

			// IMPORTANT:
			// update native input without React re-render
			target.textContent = formattedValue;

			const column = columnMeta.find(
				(item: any) => item.field === field
			);

			if (!column) {
				return;
			}

			onCellValueChange(
				column,
				rowIndex,
				numericValue,
				payrollItems[rowIndex]
			);
		},
		[columnMeta, payrollItems, onCellValueChange]
	);


	// const handleGridBlur = useCallback(
	// 	(event: React.FocusEvent<HTMLDivElement>) => {
	// 		const target = event.target as HTMLInputElement;

	// 		if (!target.dataset.payrollInput) {
	// 			return;
	// 		}

	// 		const rowIndex = Number(target.dataset.rowIndex);
	// 		const field = target.dataset.field;

	// 		if (!field) return;

	// 		const raw = target.value.trim();

	// 		const value: any =
	// 			raw === ""
	// 				? null
	// 				: Number(raw.replace(/,/g, ""));

	// 		// Format visually immediately
	// 		if (raw !== "" && !Number.isNaN(value)) {
	// 			target.value = value.toFixed(2);
	// 		}

	// 		const column = columnMeta.find(
	// 			(item: any) => item.field === field
	// 		);

	// 		if (!column) return;

	// 		// IMPORTANT:
	// 		// allow browser to complete the next focus first
	// 		requestAnimationFrame(() => {
	// 			onCellValueChange(
	// 				column,
	// 				rowIndex,
	// 				value,
	// 				payrollItems[rowIndex]
	// 			);
	// 		});
	// 	},
	// 	[columnMeta, payrollItems, onCellValueChange]
	// );

	const handleGridKeyDown = useCallback(
		(event: React.KeyboardEvent<HTMLDivElement>) => {
			const target =
				event.target as HTMLInputElement;

			if (!target.dataset.payrollInput) {
				return;
			}

			const rowIndex =
				Number(target.dataset.rowIndex);

			const field =
				target.dataset.field;

			if (!field || Number.isNaN(rowIndex)) {
				return;
			}

			const column =
				editableNumberColumnsRef.current.find(
					(item: any) =>
						item.field === field
				);

			if (!column) {
				return;
			}

			handleCellNavigation(
				event as unknown as React.KeyboardEvent<HTMLInputElement>,
				rowIndex,
				column
			);
		},
		[handleCellNavigation]
	);

	const handleGridClick = useCallback(
		(event: React.MouseEvent<HTMLDivElement>) => {
			const target = event.target as HTMLElement;
			const row = target.closest('tr');
			if (!row) return;

			const tbody = row.closest('.p-datatable-tbody');
			if (!tbody) return;

			const container = containerRef.current;
			if (!container) return;

			container
				.querySelectorAll('.highlighted-row')
				.forEach((el) => el.classList.remove('highlighted-row'));

			row.classList.add('highlighted-row');
		},
		[]
	);

	// const activeRowRef = useRef<number | null>(null);

	// const handleGridClick = useCallback(
	// 	(event: React.MouseEvent<HTMLDivElement>) => {
	// 		const target = event.target as HTMLElement;
	// 		const row = target.closest('tr');
	// 		if (!row) return;
	// 		const tbody = row.closest('.p-datatable-tbody');
	// 		if (!tbody) return;
	// 		const container = containerRef.current;
	// 		if (!container) return;

	// 		container.querySelectorAll('.highlighted-row').forEach((el) =>
	// 			el.classList.remove('highlighted-row')
	// 		);
	// 		row.classList.add('highlighted-row');

	// 		// Track for re-application after re-renders
	// 		const input: any = row.querySelector('[data-employee-id]');
	// 		activeRowRef.current = input ? Number(input.dataset.employeeId) : null;
	// 	},
	// 	[]
	// );

	// // Re-apply highlight after re-renders
	// useEffect(() => {
	// 	if (activeRowRef.current === null) return;
	// 	const container = containerRef.current;
	// 	if (!container) return;
	// 	const input = container.querySelector(`[data-employee-id="${activeRowRef.current}"]`);
	// 	input?.closest('tr')?.classList.add('highlighted-row');
	// }, [payrollItems]);

	const inputRefCallbacks = useRef(
		new Map<string, (element: HTMLInputElement | null) => void>()
	);

	const getInputRefCallback = useCallback(
		(cellKey: string) => {
			let callback =
				inputRefCallbacks.current.get(cellKey);

			if (!callback) {
				callback = (element) => {
					if (element) {
						inputRefs.current[cellKey] = element;
					} else {
						delete inputRefs.current[cellKey];
					}
				};

				inputRefCallbacks.current.set(
					cellKey,
					callback
				);
			}

			return callback;
		},
		[]
	);
	const renderNumberInput = (
		rowData: any,
		rowIndex: number,
		column: any
	) => {
		const value =
			getCellValue(rowData, column.field);

		const displayValue =
			value === null || value === undefined || value === ""
				? ""
				: Number(String(value).replace(/,/g, "")).toFixed(2);


		const cellKey =
			`${rowData.employeeId}-${column.field}`;

		return (
			<input
				// key={`${rowData.employeeId}-${column.field}`} // stable
				key={`${rowData.employeeId}-${column.field}`}
				// ref={(element) => {
				// 	if (element) {
				// 		inputRefs.current[cellKey] =
				// 			element;
				// 	} else {
				// 		delete inputRefs.current[cellKey];
				// 	}
				// }}
				// ref={(element) =>
				// 	setInputRef(cellKey, element)
				// }
				// ref={getInputRefCallback(cellKey)}
				// ref={(el) => {
				// 	const cellKey = `${rowData.employeeId}-${column.field}`;

				// 	if (el) {
				// 		inputRefs.current[cellKey] = el;
				// 	} else {
				// 		delete inputRefs.current[cellKey];
				// 	}
				// }}
				ref={getInputRefCallback(`${rowData.employeeId}-${column.field}`)}
				data-payroll-input="true"
				data-row-index={rowIndex}
				data-field={column.field}
				data-employee-id={rowData.employeeId}
				type="text"
				inputMode="decimal"
				defaultValue={displayValue}
				className={`payroll-number-input ${column.numberClassName || ""}`}


				onInput={(e) => {
					const input = e.currentTarget;

					let value = input.value;

					// Only numbers, decimal and minus
					value = value.replace(/[^\d.-]/g, "");

					// Only one decimal point
					const parts = value.split(".");

					if (parts.length > 2) {
						value = `${parts[0]}.${parts.slice(1).join("")}`;
					}

					// Maximum 2 decimal places
					const decimalParts = value.split(".");

					if (decimalParts.length === 2) {
						value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
					}

					input.value = value;
				}}
			/>
		);
	};
	const columnsBody = useCallback((rowData: any, row: any, x: any) => {
		// const value = getValueByFieldPath(rowData, x.field);

		if (x.isEditable && !rowData.salaryProfileMessage) {
			if (x.type === 'number') {
				const value = getCellValue(
					rowData,
					x.field
				);
				const displayValue =
					value === null || value === undefined || value === ""
						? ""
						// : Number(String(value).replace(/,/g, "")).toFixed(2);
						: formatAmountCommaSeperator(value)
				if (
					x.field === 'vacationPay' &&
					rowData.payOutVacationPayFlag === 200
				) {
					return (
						<span
							className="payroll-cell-text"
						// onClick={() =>
						// 	setActiveRowIndex(rowData.employeeId)
						// }
						>
							{formatAmountCommaSeperator(rowData[x.field])}
						</span>
					);
				}

				const cellKey = `${rowData.employeeId}-${x.field}`;
				// return (
				// 	// <InputNumber
				// 	// 	value={value}
				// 	// 	// onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
				// 	// 	// onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
				// 	// 	// onValueChange={(e: any) => {
				// 	// 	// 	if (!touchedCellsRef.current.has(cellKey)) return; // not user-initiated — ignore completely
				// 	// 	// 	onCellValueChange(x, row.rowIndex, e.value, rowData);
				// 	// 	// }}
				// 	// 	// placeholder="0.00"
				// 	// 	minFractionDigits={2}
				// 	// 	maxFractionDigits={2}
				// 	// 	// inputClassName={`${x.field === 'vacationPay' ? "vacationPayField" : ""}`}
				// 	// 	inputClassName={
				// 	// 		x.field === 'vacationPay' ? 'vacationPayField' :
				// 	// 			x.field === 'holidayHours' ? 'holidayHoursField' :
				// 	// 				x.field === 'holidayPay' ? 'holidayHoursField' :
				// 	// 					x.field === 'holidayPayAccured' ? 'holidayHoursField' :
				// 	// 						x.edr === 'earnings' ? 'earningsField' :
				// 	// 							x.edr === 'deductions' ? 'deductionsField' :
				// 	// 								x.edr === 'reimbursements' ? 'reimbursementsField' :
				// 	// 									''}
				// 	// 	inputStyle={{ textAlign: "right" }}
				// 	// 	// onFocus={() => setActiveRowIndex(row.rowIndex)}
				// 	// 	onFocus={() => setActiveRowIndex(rowData.employeeId)}
				// 	// 	// onFocus={() => {
				// 	// 	// 	touchedCellsRef.current.add(cellKey);
				// 	// 	// 	setActiveRowIndex(rowData.employeeId);
				// 	// 	// }}

				// 	// 	// onValueChange={(e: any) => {
				// 	// 	// 	if (!touchedCellsRef.current.has(cellKey)) return; // not user-initiated — ignore completely
				// 	// 	// 	onCellValueChange(x, row.rowIndex, e.value, rowData);
				// 	// 	// }}
				// 	// 	// onFocus={() => {
				// 	// 	// 	touchedCellsRef.current.add(cellKey);
				// 	// 	// 	setActiveRowIndex(rowData.employeeId);
				// 	// 	// }}

				// 	// 	// onChange={(e) => {
				// 	// 	// 	editingValues.current[cellKey] = Number(e.value);
				// 	// 	// }}
				// 	// 	// onBlur={() => {
				// 	// 	// 	onCellValueChange(
				// 	// 	// 		x,
				// 	// 	// 		row.rowIndex,
				// 	// 	// 		editingValues.current[cellKey],
				// 	// 	// 		rowData
				// 	// 	// 	);

				// 	// 	// 	delete editingValues.current[cellKey];
				// 	// 	// }}

				// 	// 	// onChange={(e) => {
				// 	// 	// 	// editingValues.current[cellKey] = Number(e.value);

				// 	// 	// 	editingValues.current[cellKey] = e.value;
				// 	// 	// 	// editingValues.current[cellKey] =
				// 	// 	// 	// 	e.value === null || e.value === undefined
				// 	// 	// 	// 		? null
				// 	// 	// 	// 		: e.value;
				// 	// 	// }}
				// 	// 	// onChange={() => {
				// 	// 	// 	editingValues.current[cellKey] ??= value;
				// 	// 	// }}
				// 	// 	// onValueChange={(e) => {
				// 	// 	// 	editingValues.current[cellKey] = e.value;
				// 	// 	// }}
				// 	// 	// onValueChange={(e) => {
				// 	// 	// 	editingValues.current[cellKey] = e.value ?? null;
				// 	// 	// }}
				// 	// 	// onBlur={() => {
				// 	// 	// 	const edited =
				// 	// 	// 		editingValues.current[cellKey] ?? value;

				// 	// 	// 	const editedForNull = editingValues.current[cellKey];

				// 	// 	// 	onCellValueChange(
				// 	// 	// 		x,
				// 	// 	// 		row.rowIndex,
				// 	// 	// 		// edited,
				// 	// 	// 		editedForNull,
				// 	// 	// 		// edited === null ? null : Number(editedForNull),
				// 	// 	// 		rowData
				// 	// 	// 	);

				// 	// 	// 	delete editingValues.current[cellKey];
				// 	// 	// }}
				// 	// 	// onBlur={() => {
				// 	// 	// 	if (!(cellKey in editingValues.current)) return;


				// 	// 	// 	onCellValueChange(
				// 	// 	// 		x,
				// 	// 	// 		row.rowIndex,
				// 	// 	// 		editingValues.current[cellKey],
				// 	// 	// 		rowData
				// 	// 	// 	);

				// 	// 	// 	delete editingValues.current[cellKey];
				// 	// 	// }}

				// 	// 	// onChange={(e: any) => {
				// 	// 	// 	editingValues.current[cellKey] =
				// 	// 	// 		e.originalEvent.target.value === ""
				// 	// 	// 			? null
				// 	// 	// 			: e.value;
				// 	// 	// }}

				// 	// 	// onValueChange={(e: any) => {
				// 	// 	// 	editingValues.current[cellKey] =
				// 	// 	// 		e.originalEvent.target.value === ""
				// 	// 	// 			? null
				// 	// 	// 			: e.value;
				// 	// 	// }}
				// 	// 	// onBlur={() => {
				// 	// 	// 	if (!(cellKey in editingValues.current)) return;


				// 	// 	// 	onCellValueChange(
				// 	// 	// 		x,
				// 	// 	// 		row.rowIndex,
				// 	// 	// 		editingValues.current[cellKey],
				// 	// 	// 		rowData
				// 	// 	// 	);

				// 	// 	// 	delete editingValues.current[cellKey];
				// 	// 	// }}

				// 	// 	// inputRef={(el) => (inputRefs.current[cellKey] = el)}
				// 	// 	inputRef={(el) => {
				// 	// 		inputRefs.current[cellKey] = el;
				// 	// 	}}
				// 	// 	onBlur={() => {
				// 	// 		const raw = inputRefs.current[cellKey]?.value;

				// 	// 		let edited: number | null;

				// 	// 		if (raw === "" || raw == null) {
				// 	// 			edited = null;
				// 	// 		} else {
				// 	// 			edited = Number(raw.replace(/,/g, ""));
				// 	// 		}

				// 	// 		onCellValueChange(
				// 	// 			x,
				// 	// 			row.rowIndex,
				// 	// 			edited,
				// 	// 			rowData
				// 	// 		);
				// 	// 	}}

				// 	// 	onKeyDown={(e) => {
				// 	// 		handleCellNavigation(e, row.rowIndex, x);
				// 	// 	}}

				// 	// />

				// 	// <PayrollNumberCell
				// 	// 	value={value}
				// 	// 	cellKey={cellKey}
				// 	// 	column={x}
				// 	// 	rowIndex={row.rowIndex}
				// 	// 	employeeId={rowData.employeeId}
				// 	// 	rowData={rowData}
				// 	// 	onCellValueChange={onCellValueChange}
				// 	// 	setActiveRowIndex={setActiveRowIndex}
				// 	// 	inputRefs={inputRefs}
				// 	// 	handleCellNavigation={handleCellNavigation}
				// 	// 	inputClassName={getNumberFieldClass(x)}
				// 	// />

				// 	<PayrollNumberCell
				// 		value={value}
				// 		cellKey={cellKey}
				// 		column={x}
				// 		rowIndex={row.rowIndex}
				// 		employeeId={rowData.employeeId}
				// 		rowData={rowData}
				// 		onCellValueChange={onCellValueChange}
				// 		setActiveRowIndex={setActiveRowIndex}
				// 		// setInputRef={setInputRef}
				// 		handleCellNavigation={handleCellNavigation}
				// 		inputClassName={getNumberFieldClass(x)}
				// 		inputRefs={inputRefs}
				// 	/>
				// )

				// return renderNumberInput(
				// 	rowData,
				// 	row.rowIndex,
				// 	x
				// );

				return (
					// <NumberCell
					// 	key={cellKey}
					// 	rowIndex={row.rowIndex}
					// 	field={x.field}
					// 	employeeId={rowData.employeeId}
					// 	displayValue={displayValue}
					// 	className={`payroll-number-input ${getNumberFieldClass(x) || ""}`}
					// 	registerRef={getInputRefCallback(cellKey)}
					// />

					<NumberCell
						key={cellKey}
						rowIndex={row.rowIndex}
						field={x.field}
						employeeId={rowData.employeeId}
						displayValue={displayValue}
						className={`payroll-number-input ${getNumberFieldClass(x) || ""}`}
						registerRef={getInputRefCallback(cellKey)}
						column={x}                          // CHANGED
						onCellKeyDown={handleCellNavigation} // CHANGED
					/>
				);

				// return <></>;
			} else if (!rowData.hasOwnProperty("vacationPayAccured") && rowData.hasOwnProperty("vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined") && rowData["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] != null) {

				return (
					<span
						className="payroll-cell-text"
					// onClick={() => setActiveRowIndex(rowData.employeeId)}
					>
						{formatAmountCommaSeperator(rowData["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"])}
					</span>
				)
			} else if (rowData.hasOwnProperty("vacationPayAccured")) {

				return (
					// <span onClick={() => setActiveRowIndex(rowData.employeeId)}>
					// 	{rowData[x.field]}
					// </span>
					<span
						className="payroll-cell-text"
					// onClick={() => setActiveRowIndex(rowData.employeeId)}
					>
						{formatAmountCommaSeperator(rowData[x.field])}
					</span>
				)
			}
		} else if (x.isEditable && rowData.salaryProfileMessage !== null && x.field === "regularHours") {
			return (
				// <span onClick={() => setActiveRowIndex(rowData.employeeId)}
				// 	className="salaryProfileMessage">
				// 	{rowData.salaryProfileMessage}
				// </span>
				<span
					className="payroll-cell-text salaryProfileMessage"
				// onClick={() => setActiveRowIndex(rowData.employeeId)}
				>
					{rowData.salaryProfileMessage}
				</span>
			)
		} else if (x.isEditable && rowData.salaryProfileMessage !== null && x.field !== "regularHours" && x.field !== "employeeName" && x.field !== "employeeNumberId" && x.field !== "sequenceNumber") {
			return (
				<span
					// onClick={() => setActiveRowIndex(rowData.employeeId)} 
					style={{ display: "block" }}>&nbsp;</span>
			)
		} else if (x.field === "employeeName") {
			return (
				// <Link
				// 	to={`#`}
				// 	className="no-underline"
				// 	style={{ color: theme.palette.primary.light }}
				// 	onClick={() => onEmployeeNameClickedHandler(rowData)}
				// >
				// 	{rowData[x.field]}
				// </Link>
				<span
					className="no-underline payroll-cell-text"
					style={{ fontSize: ".875rem", color: theme.palette.primary.light, cursor: "pointer" }}
					onClick={() => onEmployeeNameClickedHandler(rowData)}
				>
					{rowData[x.field]}
				</span>
			)
		} else if (x.field === "sequenceNumber") {
			return (
				// <Link
				// 	to={`#`}
				// 	className="no-underline"
				// 	style={{ color: theme.palette.primary.light }}
				// 	onClick={() => onSequenceNumberClickedHandler(rowData)}
				// >
				// 	{rowData[x.field]}
				// </Link>
				<span
					className="no-underline payroll-cell-text"
					style={{ fontSize: ".875rem", color: theme.palette.primary.light, cursor: "pointer" }}
					onClick={() => onSequenceNumberClickedHandler(rowData)}
				>
					{rowData[x.field]}
				</span>
			)
		} else if (x.field === "total" && !rowData.salaryProfileMessage) {
			return (
				<span
					className="payroll-cell-text"
				// onClick={() => setActiveRowIndex(rowData.employeeId)}
				>
					{formatAmountCommaSeperator(rowData.total)}
				</span>
			)
		} else if (x.field === "total" && rowData.salaryProfileMessage !== null) {
			return (
				<span
					className="payroll-cell-text"
				// onClick={() => setActiveRowIndex(rowData.employeeId)}
				>

				</span>
			)
		} else {

			return (
				// <span onClick={() => setActiveRowIndex(rowData.employeeId)}>
				// 	{rowData[x.field]}
				// </span>
				<span
					className="payroll-cell-text"
				// onClick={() => setActiveRowIndex(rowData.employeeId)}
				>
					{rowData[x.field]}
				</span>
			)
		}
	},
		[
			onCellValueChange,
			handleCellNavigation,
			// setActiveRowIndex,
		]
	);

	// const containerRef = useRef<HTMLDivElement>(null);
	// const [containerWidth, setContainerWidth] = useState(0);
	// // const [totalColumnWidth, setTotalColumnWidth] = useState(0);

	// // useEffect(() => {
	// // 	if (!containerRef.current) return;
	// // 	const observer = new ResizeObserver(([entry]) => {
	// // 		setContainerWidth(entry.contentRect.width);
	// // 	});
	// // 	observer.observe(containerRef.current);
	// // 	return () => observer.disconnect();
	// // }, []);
	// // useEffect(() => {
	// // 	// compute total defined width of all columns
	// // 	const totalColumnWidth = columns && columns.reduce(
	// // 		(sum: any, col: any) => sum + (col.maxWidth || 0),
	// // 		0
	// // 	);
	// // 	setTotalColumnWidth(totalColumnWidth)
	// // }, [columns]);

	// const totalColumnWidth = useMemo(() => {
	// 	return columns?.reduce(
	// 		(sum: number, col: any) =>
	// 			sum + (Number(col.maxWidth) || 0),
	// 		0
	// 	) ?? 0;
	// }, [columns]);

	// // useEffect(() => {
	// // 	const element = containerRef.current;

	// // 	if (!element) return;

	// // 	const observer = new ResizeObserver(([entry]) => {
	// // 		const width = entry.contentRect.width;

	// // 		setContainerWidth(prev =>
	// // 			prev === width ? prev : width
	// // 		);
	// // 	});

	// // 	observer.observe(element);

	// // 	return () => observer.disconnect();
	// // }, []);

	// useLayoutEffect(() => {
	// 	const updateWidth = () => {
	// 		const width = containerRef.current?.clientWidth ?? 0;

	// 		setContainerWidth((prev) =>
	// 			prev === width ? prev : width
	// 		);
	// 	};

	// 	requestAnimationFrame(updateWidth);

	// 	window.addEventListener("resize", updateWidth);

	// 	return () => {
	// 		window.removeEventListener("resize", updateWidth);
	// 	};
	// }, []);

	// const shouldFitContainer =
	// 	totalColumnWidth < containerWidth;

	const containerRef = useRef<HTMLDivElement>(null);
	const [containerWidth, setContainerWidth] = useState(0);

	const totalColumnWidth = useMemo(() => {
		return columns?.reduce(
			(sum: number, col: any) => sum + (Number(col.maxWidth) || 0),
			0
		) ?? 0;
	}, [columns]);

	// const totalColumnWidth = gridsMaxTotalWidth ?? 0;

	const columnCount = columns?.length ?? 0;
	const useFitContainerLogic = columnCount <= 10;

	useLayoutEffect(() => {
		// Skip the measurement entirely for wide grids — this is the case
		// that was costing the extra render/layout pass.
		if (!useFitContainerLogic) return;

		const updateWidth = () => {
			const width = containerRef.current?.clientWidth ?? 0;

			setContainerWidth((prev) =>
				prev === width ? prev : width
			);
		};

		requestAnimationFrame(updateWidth);

		window.addEventListener("resize", updateWidth);

		return () => {
			window.removeEventListener("resize", updateWidth);
		};
	}, [useFitContainerLogic]);

	const shouldFitContainer =
		useFitContainerLogic && totalColumnWidth < containerWidth;




	// // row highlighting (yellow background) when clicking any cell in that row
	// const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);


	// const getRowClassName = (data: any, options: any) => {
	// 	return data.employeeId === activeRowIndex ? "highlighted-row" : "";
	// };

	// const activeRowIndexRef = useRef<number | null>(null);
	// const setActiveRowIndex = useCallback((employeeId: number | null) => {
	// 	if (activeRowIndexRef.current === employeeId) return;

	// 	activeRowIndexRef.current = employeeId;

	// 	const container = containerRef.current;
	// 	if (!container) return;

	// 	container.querySelectorAll('.highlighted-row').forEach((el) => {
	// 		el.classList.remove('highlighted-row');
	// 	});

	// 	if (employeeId !== null) {
	// 		const input = container.querySelector(
	// 			`[data-employee-id="${employeeId}"]`
	// 		);
	// 		input?.closest('tr')?.classList.add('highlighted-row');
	// 	}
	// }, []);
	// const getRowClassName = useCallback((data: any) => {
	// 	return data.employeeId === activeRowIndexRef.current
	// 		? "highlighted-row"
	// 		: "";
	// }, []);



	const columnsKey = useMemo(
		() =>
			columns
				?.map((column: any) =>
					`${column.field}:${column.hide}:${column.maxWidth}`
				)
				.join("|"),
		[columns]
	);

	// ─── STICKY HEADER USEEFFECT ───────────────────────────────────────────────
	// useEffect(() => {
	// 	const NAVBAR_HEIGHT = 112;
	// 	let stickyTable: HTMLElement | null = null;
	// 	// const getScrollSource = (): HTMLElement | null => {
	// 	// 	return (
	// 	// 		pageScrollContainerRef?.current ||
	// 	// 		(containerRef.current?.closest(".payroll-grids-scroll-container") as HTMLElement | null)
	// 	// 	);
	// 	// };
	// 	const syncHorizontalScroll = () => {
	// 		if (!stickyTable || !containerRef.current) return;
	// 		// const scrollSource = getScrollSource();
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		const clipWrapper = stickyTable.querySelector('[data-clip-wrapper]') as HTMLElement;
	// 		const cloneTable = stickyTable.querySelector('table') as HTMLElement;
	// 		if (!wrapper || !cloneTable || !clipWrapper) return;
	// 		// if (!scrollSource || !cloneTable || !clipWrapper) return;

	// 		const scrollLeft = wrapper.scrollLeft;
	// 		// const scrollLeft = scrollSource.scrollLeft;

	// 		// Move the clip wrapper left (clips non-frozen columns at frozen boundary)
	// 		// Frozen columns are OUTSIDE this wrapper so they never move
	// 		cloneTable.style.transform = `translateX(-${scrollLeft}px)`;

	// 		const cloneThs = cloneTable.querySelectorAll('th') as NodeListOf<HTMLElement>;
	// 		const originalThs = containerRef.current.querySelectorAll('.p-datatable-thead th') as NodeListOf<HTMLElement>;


	// 		cloneThs.forEach((cloneTh, i) => {
	// 			const originalTh = originalThs[i] as HTMLElement;
	// 			if (!originalTh) return;

	// 			const isFrozen =
	// 				originalTh.classList.contains('p-frozen-column') ||
	// 				originalTh.classList.contains('selectionHeader');

	// 			if (isFrozen) {
	// 				// Counter-translate frozen columns — pin them back
	// 				cloneTh.style.transform = `translateX(${scrollLeft}px)`;
	// 				cloneTh.style.borderLeft = '1px solid #e5e7eb';
	// 				// cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 				cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 				cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 				cloneTh.style.backgroundColor = '#ffffff';
	// 				cloneTh.style.zIndex = '20';
	// 				cloneTh.style.position = 'sticky';
	// 			} else {
	// 				cloneTh.style.transform = '';
	// 				cloneTh.style.borderLeft = '1px solid #e5e7eb';
	// 				// cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 				cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 				cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 			}

	// 			// when we dont need frozen selection column 

	// 			// cloneTh.style.transform = '';
	// 			// cloneTh.style.borderLeft = '1px solid #e5e7eb';
	// 			// // cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 			// cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 			// cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 		});
	// 	};

	// 	const createStickyHeader = () => {
	// 		if (!containerRef.current) return;
	// 		const originalTable = containerRef.current.querySelector('.p-datatable-table') as HTMLElement;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		// const scrollSource = getScrollSource();
	// 		// if (!originalTable || !originalThead || !scrollSource) return;
	// 		if (!originalTable || !originalThead || !wrapper) return;

	// 		document.querySelector('[data-sticky-table]')?.remove();

	// 		const containerRect = containerRef.current.getBoundingClientRect();

	// 		const fixedContainer = document.createElement('div');
	// 		fixedContainer.setAttribute('data-sticky-table', 'true');
	// 		fixedContainer.style.cssText = `
	// 			position: fixed;
	// 			top: ${NAVBAR_HEIGHT}px;
	// 			left: ${containerRect.left}px;
	// 			width: ${containerRect.width}px;
	// 			overflow: hidden;
	// 			z-index: 999;
	// 			background: #ffffff;
	// 		`;

	// 		// const cloneTable = originalTable.cloneNode(true) as HTMLElement;

	// 		const cloneTable =
	// 			document.createElement("table");

	// 		cloneTable.className =
	// 			"p-datatable-table";

	// 		const clonedThead =
	// 			originalThead.cloneNode(
	// 				true
	// 			) as HTMLElement;

	// 		cloneTable.appendChild(
	// 			clonedThead
	// 		);

	// 		// ── KEY FIX: use separate borders instead of border-collapse ──────────
	// 		// border-collapse causes shared borders that break when translateX is applied
	// 		cloneTable.style.cssText = `
	// 			table-layout: fixed;
	// 			width: ${originalTable.offsetWidth}px;
	// 			margin: 0;
	// 			border-collapse: separate;
	// 			border-spacing: 0;
	// 			transform: translateX(-${wrapper.scrollLeft}px);
	// 		`;

	// 		cloneTable.querySelector('.p-datatable-tbody')?.remove();
	// 		cloneTable.querySelector('.p-datatable-tfoot')?.remove();

	// 		const originalThs = originalThead.querySelectorAll('th') as NodeListOf<HTMLElement>;
	// 		const cloneThs = cloneTable.querySelectorAll('th') as NodeListOf<HTMLElement>;

	// 		// Calculate frozen columns total width for clip wrapper offset

	// 		// when we dont need frozen selection column  comment this
	// 		let frozenWidth = 0;

	// 		// originalThs.forEach((th, i) => {
	// 		// 	const cloneTh = cloneThs[i] as HTMLElement;
	// 		// 	if (!cloneTh) return;

	// 		// 	const width = th.getBoundingClientRect().width;
	// 		// 	const computedStyle = window.getComputedStyle(th);
	// 		// 	const computedBg = computedStyle.backgroundColor;
	// 		// 	const isFrozen =
	// 		// 		th.classList.contains('p-frozen-column') ||
	// 		// 		th.classList.contains('selectionHeader');

	// 		// 	if (isFrozen) frozenWidth += width;

	// 		// 	cloneTh.style.width = `${width}px`;
	// 		// 	cloneTh.style.minWidth = `${width}px`;
	// 		// 	cloneTh.style.maxWidth = `${width}px`;
	// 		// 	// ── Every th gets ALL 4 borders explicitly ────────────────────────
	// 		// 	cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 		// 	cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 		// 	// cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 		// 	cloneTh.style.borderLeft = '1px solid #e5e7eb';  // ← ALL columns get left border
	// 		// 	cloneTh.style.boxSizing = 'border-box';
	// 		// 	cloneTh.style.backgroundColor = (computedBg && computedBg !== 'rgba(0, 0, 0, 0)') ? computedBg : '#ffffff';
	// 		// 	cloneTh.style.color = computedStyle.color || '#0091b3';
	// 		// 	cloneTh.style.fontWeight = 'bold';
	// 		// 	cloneTh.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 		// 	cloneTh.style.fontFamily = computedStyle.fontFamily;
	// 		// 	cloneTh.style.textAlign = 'left';
	// 		// 	cloneTh.style.padding = '6px';
	// 		// 	cloneTh.style.whiteSpace = 'nowrap';
	// 		// 	cloneTh.style.overflow = 'hidden';
	// 		// 	cloneTh.style.textOverflow = 'ellipsis';
	// 		// 	cloneTh.style.verticalAlign = 'middle';

	// 		// 	if (isFrozen) {
	// 		// 		cloneTh.style.position = 'sticky';
	// 		// 		cloneTh.style.left = th.style.left || '0px';
	// 		// 		cloneTh.style.zIndex = '20';
	// 		// 		cloneTh.style.backgroundColor = '#ffffff';
	// 		// 		// Shadow on RIGHT side of last frozen column only
	// 		// 	} else {
	// 		// 		cloneTh.style.position = '';
	// 		// 		cloneTh.style.left = '';
	// 		// 		cloneTh.style.zIndex = '1';
	// 		// 	}

	// 		// 	const headerContent = cloneTh.querySelector('.p-column-header-content') as HTMLElement;
	// 		// 	if (headerContent) {
	// 		// 		headerContent.style.display = 'flex';
	// 		// 		headerContent.style.alignItems = 'center';
	// 		// 		headerContent.style.color = computedStyle.color || '#0091b3';
	// 		// 		headerContent.style.fontWeight = 'bold';
	// 		// 	}

	// 		// 	// const titleSpan = cloneTh.querySelector('.p-column-title') as HTMLElement;
	// 		// 	// if (titleSpan) {
	// 		// 	// 	titleSpan.style.color = computedStyle.color || '#0091b3';
	// 		// 	// 	titleSpan.style.fontWeight = 'bold';
	// 		// 	// 	titleSpan.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 		// 	// 	titleSpan.style.whiteSpace = 'nowrap';
	// 		// 	// 	titleSpan.style.display = 'inline-block';

	// 		// 	// 	// ── measure natural width BEFORE applying clip styles ──
	// 		// 	// 	const naturalWidth = titleSpan.scrollWidth;

	// 		// 	// 	titleSpan.style.maxWidth = '120px';
	// 		// 	// 	titleSpan.style.overflow = 'hidden';
	// 		// 	// 	titleSpan.style.textOverflow = 'ellipsis';

	// 		// 	// 	// only set title if text would be truncated
	// 		// 	// 	cloneTh.title = naturalWidth > 120 ? titleSpan.textContent || '' : '';
	// 		// 	// }

	// 		// 	originalThs.forEach((th, i) => {
	// 		// 		const cloneTh = cloneThs[i] as HTMLElement;
	// 		// 		if (!cloneTh) return;

	// 		// 		// ... all your existing styles ...

	// 		// 		const titleSpan = cloneTh.querySelector('.p-column-title') as HTMLElement;
	// 		// 		// ── measure from ORIGINAL th (it's in the DOM) ──
	// 		// 		const originalTitleSpan = th.querySelector('.p-column-title') as HTMLElement;

	// 		// 		if (titleSpan && originalTitleSpan) {
	// 		// 			titleSpan.style.color = computedStyle.color || '#0091b3';
	// 		// 			titleSpan.style.fontWeight = 'bold';
	// 		// 			titleSpan.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 		// 			titleSpan.style.whiteSpace = 'nowrap';
	// 		// 			titleSpan.style.display = 'inline-block';
	// 		// 			titleSpan.style.maxWidth = '120px';
	// 		// 			titleSpan.style.overflow = 'hidden';
	// 		// 			titleSpan.style.textOverflow = 'ellipsis';

	// 		// 			// measure natural width from original (already in DOM)
	// 		// 			const prevMaxWidth = originalTitleSpan.style.maxWidth;
	// 		// 			originalTitleSpan.style.maxWidth = 'none';
	// 		// 			const naturalWidth = originalTitleSpan.scrollWidth;
	// 		// 			originalTitleSpan.style.maxWidth = prevMaxWidth;

	// 		// 			// only show tooltip if truncated
	// 		// 			cloneTh.title = naturalWidth > 120 ? titleSpan.textContent || '' : '';
	// 		// 		}
	// 		// 	});
	// 		// });

	// 		originalThs.forEach(
	// 			(th, i) => {
	// 				const cloneTh =
	// 					cloneThs[i] as HTMLElement;

	// 				if (!cloneTh) return;

	// 				const width =
	// 					th.getBoundingClientRect()
	// 						.width;

	// 				const computedStyle =
	// 					window.getComputedStyle(th);

	// 				const computedBg = computedStyle.backgroundColor;

	// 				// when we dont need frozen selection column comment this 
	// 				const isFrozen =
	// 					th.classList.contains('p-frozen-column') ||
	// 					th.classList.contains('selectionHeader');

	// 				if (isFrozen) frozenWidth += width;

	// 				cloneTh.style.width = `${width}px`;
	// 				cloneTh.style.minWidth = `${width}px`;
	// 				cloneTh.style.maxWidth = `${width}px`;
	// 				// ── Every th gets ALL 4 borders explicitly ────────────────────────
	// 				cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 				cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 				// cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 				cloneTh.style.borderLeft = '1px solid #e5e7eb';  // ← ALL columns get left border
	// 				cloneTh.style.boxSizing = 'border-box';
	// 				cloneTh.style.backgroundColor = (computedBg && computedBg !== 'rgba(0, 0, 0, 0)') ? computedBg : '#ffffff';
	// 				cloneTh.style.color = computedStyle.color || '#0091b3';
	// 				cloneTh.style.fontWeight = 'bold';
	// 				cloneTh.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 				cloneTh.style.fontFamily = computedStyle.fontFamily;
	// 				cloneTh.style.textAlign = 'left';
	// 				cloneTh.style.padding = '6px';
	// 				cloneTh.style.whiteSpace = 'nowrap';
	// 				cloneTh.style.overflow = 'hidden';
	// 				cloneTh.style.textOverflow = 'ellipsis';
	// 				cloneTh.style.verticalAlign = 'middle';

	// 				if (isFrozen) {
	// 					cloneTh.style.position = 'sticky';
	// 					cloneTh.style.left = th.style.left || '0px';
	// 					cloneTh.style.zIndex = '20';
	// 					cloneTh.style.backgroundColor = '#ffffff';
	// 					// Shadow on RIGHT side of last frozen column only
	// 				} else {
	// 					cloneTh.style.position = '';
	// 					cloneTh.style.left = '';
	// 					cloneTh.style.zIndex = '1';
	// 				}

	// 				// when we dont need frozen selection column 
	// 				// cloneTh.style.position = '';
	// 				// cloneTh.style.left = '';
	// 				// cloneTh.style.zIndex = '1';

	// 				const headerContent = cloneTh.querySelector('.p-column-header-content') as HTMLElement;
	// 				if (headerContent) {
	// 					headerContent.style.display = 'flex';
	// 					headerContent.style.alignItems = 'center';
	// 					headerContent.style.color = computedStyle.color || '#0091b3';
	// 					headerContent.style.fontWeight = 'bold';
	// 				}


	// 				const titleSpan =
	// 					cloneTh.querySelector(
	// 						".p-column-title"
	// 					) as HTMLElement;

	// 				if (titleSpan) {
	// 					titleSpan.style.color =
	// 						computedStyle.color;

	// 					titleSpan.style.fontWeight =
	// 						"bold";

	// 					titleSpan.style.fontSize =
	// 						computedStyle.fontSize ||
	// 						"0.9rem";

	// 					titleSpan.style.whiteSpace =
	// 						"nowrap";

	// 					titleSpan.style.maxWidth =
	// 						"120px";

	// 					titleSpan.style.overflow =
	// 						"hidden";

	// 					titleSpan.style.textOverflow =
	// 						"ellipsis";
	// 				}
	// 			}
	// 		);

	// 		// ── Selection column ──────────────────────────────────────────────────
	// 		const cloneSelectionTh = cloneTable.querySelector('.selectionHeader') as HTMLElement;
	// 		if (cloneSelectionTh) {
	// 			cloneSelectionTh.style.width = '35px';
	// 			cloneSelectionTh.style.minWidth = '35px';
	// 			cloneSelectionTh.style.maxWidth = '35px';
	// 			cloneSelectionTh.style.textAlign = 'center';
	// 			cloneSelectionTh.style.padding = '0';
	// 			cloneSelectionTh.style.position = 'sticky';
	// 			cloneSelectionTh.style.left = '0px';
	// 			cloneSelectionTh.style.zIndex = '20';

	// 			// when we dont need frozen selection column 
	// 			// cloneSelectionTh.style.position = '';
	// 			// cloneSelectionTh.style.left = '';
	// 			// cloneSelectionTh.style.zIndex = '1';


	// 			cloneSelectionTh.style.backgroundColor = '#ffffff';
	// 			cloneSelectionTh.style.borderLeft = '1px solid #e5e7eb';
	// 			// cloneSelectionTh.style.borderRight = '1px solid #e5e7eb';
	// 			cloneSelectionTh.style.borderTop = '1px solid #e5e7eb';
	// 			cloneSelectionTh.style.borderBottom = '2px solid #e5e7eb';

	// 			const headerContent = cloneSelectionTh.querySelector('.p-column-header-content') as HTMLElement;
	// 			if (headerContent) {
	// 				headerContent.style.display = 'flex';
	// 				headerContent.style.justifyContent = 'center';
	// 				headerContent.style.alignItems = 'center';
	// 				headerContent.style.width = '100%';
	// 				headerContent.style.height = '100%';
	// 				headerContent.style.padding = '0';
	// 			}

	// 			cloneSelectionTh.querySelectorAll('*').forEach((el: any) => {
	// 				el.style.pointerEvents = 'none';
	// 			});

	// 			const overlay = document.createElement('div');
	// 			overlay.style.cssText = `
	// 				position: absolute;
	// 				top: 0; left: 0;
	// 				width: 100%; height: 100%;
	// 				cursor: pointer;
	// 				z-index: 30;
	// 				background: transparent;
	// 			`;

	// 			overlay.addEventListener('click', (e) => {
	// 				e.preventDefault();
	// 				e.stopPropagation();
	// 				const originalInput = originalThead.querySelector(
	// 					'.selectionHeader input[type="checkbox"]'
	// 				) as HTMLInputElement;
	// 				if (originalInput) {
	// 					originalInput.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
	// 					originalInput.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
	// 					originalInput.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 				const originalBox = originalThead.querySelector('.selectionHeader .p-checkbox-box') as HTMLElement;
	// 				if (originalBox) {
	// 					originalBox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 				const originalWrapper = originalThead.querySelector('.selectionHeader .p-checkbox') as HTMLElement;
	// 				if (originalWrapper) {
	// 					originalWrapper.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 			});

	// 			cloneSelectionTh.appendChild(overlay);
	// 		}

	// 		// ── Wrap in a div tagged for clip reference ───────────────────────────
	// 		const clipWrapper = document.createElement('div');
	// 		clipWrapper.setAttribute('data-clip-wrapper', 'true');
	// 		clipWrapper.style.cssText = `
	// 			position: relative;
	// 			overflow: hidden;
	// 			width: 100%;
	// 		`;
	// 		clipWrapper.appendChild(cloneTable);
	// 		fixedContainer.appendChild(clipWrapper);
	// 		document.body.appendChild(fixedContainer);
	// 		stickyTable = fixedContainer;

	// 		// Hide original thead
	// 		originalThead.style.visibility = 'hidden';
	// 		originalThead.style.opacity = '0';
	// 		originalThead.style.pointerEvents = 'none';

	// 		// ── Checkbox visual sync ──────────────────────────────────────────────
	// 		const cloneCheckboxWrapper = cloneTable.querySelector('.selectionHeader .p-checkbox') as HTMLElement;
	// 		const cloneCheckboxBox = cloneTable.querySelector('.selectionHeader .p-checkbox-box') as HTMLElement;

	// 		const syncCheckboxVisual = () => {
	// 			if (!containerRef.current || !cloneCheckboxWrapper || !cloneCheckboxBox) return;

	// 			const allRows = containerRef.current.querySelectorAll('.p-datatable-tbody .p-checkbox');
	// 			const highlightedRows = containerRef.current.querySelectorAll('.p-datatable-tbody .p-checkbox.p-highlight');
	// 			const total = allRows.length;
	// 			const checked = highlightedRows.length;

	// 			if (total === 0 || checked === 0) {
	// 				cloneCheckboxWrapper.classList.remove('p-highlight');
	// 				cloneCheckboxBox.classList.remove('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '';
	// 				cloneCheckboxBox.style.borderColor = '';
	// 				cloneCheckboxBox.innerHTML = '';
	// 			} else if (checked === total) {
	// 				cloneCheckboxWrapper.classList.add('p-highlight');
	// 				cloneCheckboxBox.classList.add('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '#6366f1';
	// 				cloneCheckboxBox.style.borderColor = '#6366f1';
	// 				cloneCheckboxBox.innerHTML = `
	// 					<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;display:block;">
	// 						<path d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
	// 							stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	// 					</svg>
	// 				`;
	// 			} else {
	// 				// cloneCheckboxWrapper.classList.add('p-highlight');
	// 				// cloneCheckboxBox.classList.add('p-highlight');
	// 				// cloneCheckboxBox.style.backgroundColor = '#6366f1';
	// 				// cloneCheckboxBox.style.borderColor = '#6366f1';
	// 				// cloneCheckboxBox.innerHTML = `
	// 				// 	<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;display:block;">
	// 				// 		<path d="M2.33325 7H11.6666"
	// 				// 			stroke="white" stroke-width="2" stroke-linecap="round"/>
	// 				// 	</svg>
	// 				// `;

	// 				cloneCheckboxWrapper.classList.remove('p-highlight');
	// 				cloneCheckboxBox.classList.remove('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '';
	// 				cloneCheckboxBox.style.borderColor = '';
	// 				cloneCheckboxBox.innerHTML = '';
	// 			}
	// 		};

	// 		syncCheckboxVisual();
	// 		// const pollInterval = setInterval(syncCheckboxVisual, 80);
	// 		// (stickyTable as any)._pollInterval = pollInterval;

	// 		const tbody = containerRef.current?.querySelector('.p-datatable-tbody') as HTMLElement;
	// 		const observer = new MutationObserver(() => {
	// 			requestAnimationFrame(syncCheckboxVisual);
	// 		});
	// 		if (tbody) {
	// 			observer.observe(tbody, {
	// 				attributes: true,
	// 				attributeFilter: ['class'],
	// 				subtree: true,
	// 			});
	// 		}
	// 		(stickyTable as any)._checkboxObserver = observer;

	// 		// when we dont need frozen selection column 
	// 		// scrollSource.addEventListener('scroll', syncHorizontalScroll, { passive: true });
	// 		wrapper.addEventListener('scroll', syncHorizontalScroll, { passive: true });
	// 	};

	// 	const removeSticky = () => {
	// 		const existing = document.querySelector('[data-sticky-table]') as any;
	// 		if (existing?._checkboxObserver) existing._checkboxObserver.disconnect();
	// 		if (existing?._pollInterval) clearInterval(existing._pollInterval);
	// 		document.querySelector('[data-sticky-table]')?.remove();
	// 		stickyTable = null;
	// 		if (!containerRef.current) return;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		if (originalThead) {
	// 			originalThead.style.visibility = 'visible';
	// 			originalThead.style.opacity = '1';
	// 			originalThead.style.pointerEvents = '';
	// 		}
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		// const scrollSource = getScrollSource();
	// 		wrapper?.removeEventListener('scroll', syncHorizontalScroll);
	// 	};

	// 	const handleScroll = () => {
	// 		if (!containerRef.current) return;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		if (!originalThead) return;

	// 		const tableRect = containerRef.current.getBoundingClientRect();
	// 		const theadHeight = originalThead.getBoundingClientRect().height;

	// 		if (tableRect.top <= NAVBAR_HEIGHT && tableRect.bottom > NAVBAR_HEIGHT + theadHeight) {
	// 			if (!stickyTable) {
	// 				createStickyHeader();
	// 			} else {
	// 				const containerRect = containerRef.current.getBoundingClientRect();
	// 				stickyTable.style.left = `${containerRect.left}px`;
	// 				stickyTable.style.width = `${containerRect.width}px`;
	// 				syncHorizontalScroll();
	// 			}
	// 		} else {
	// 			if (stickyTable) removeSticky();
	// 		}
	// 	};

	// 	const handleResize = () => { if (stickyTable) removeSticky(); };

	// 	window.addEventListener('scroll', handleScroll, { passive: true });
	// 	window.addEventListener('resize', handleResize);

	// 	if (containerRef.current) {
	// 		const originalThs = containerRef.current.querySelectorAll(
	// 			'.p-datatable-thead > tr > th'
	// 		) as NodeListOf<HTMLElement>;

	// 		originalThs.forEach((th) => {
	// 			const titleSpan = th.querySelector('.p-column-title') as HTMLElement;
	// 			if (titleSpan) {
	// 				// temporarily remove max-width to get natural scroll width
	// 				const prevMaxWidth = titleSpan.style.maxWidth;
	// 				titleSpan.style.maxWidth = 'none';
	// 				const naturalWidth = titleSpan.scrollWidth;
	// 				titleSpan.style.maxWidth = prevMaxWidth;

	// 				th.title = naturalWidth > 120 ? titleSpan.textContent || '' : '';
	// 			}
	// 		});
	// 	}

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 		window.removeEventListener('resize', handleResize);
	// 		removeSticky();
	// 	};
	// }, [columnsKey,
	// 	//  pageScrollContainerRef
	// ]);


	// Stable per-instance id so the shared coordinator can tell grids apart
	const gridInstanceId = useRef(
		`payroll-grid-${Math.random().toString(36).slice(2)}`
	).current;

	useEffect(() => {
		registerStickyGrid({
			id: gridInstanceId,
			getContainerEl: () => containerRef.current,
			getScrollSourceEl: () =>
				pageScrollContainerRef?.current ||
				(containerRef.current?.closest(".payroll-grids-scroll-container") as HTMLElement | null),
			getFrozenColumnsEnabled: () => enableFrozenColumnsRef.current,
		});

		return () => {
			unregisterStickyGrid(gridInstanceId);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Force a re-evaluation when columns change (widths/visibility), same trigger as before
	useEffect(() => {
		refreshStickyGrid(gridInstanceId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [columnsKey, pageScrollContainerRef]);

	// Keep your existing header-title tooltip logic — unrelated to the sticky singleton
	useEffect(() => {
		if (containerRef.current) {
			const originalThs = containerRef.current.querySelectorAll(
				'.p-datatable-thead > tr > th'
			) as NodeListOf<HTMLElement>;

			originalThs.forEach((th) => {
				const titleSpan = th.querySelector('.p-column-title') as HTMLElement;
				if (titleSpan) {
					const prevMaxWidth = titleSpan.style.maxWidth;
					titleSpan.style.maxWidth = 'none';
					const naturalWidth = titleSpan.scrollWidth;
					titleSpan.style.maxWidth = prevMaxWidth;

					th.title = naturalWidth > 120 ? titleSpan.textContent || '' : '';
				}
			});
		}
	}, [columnsKey]);

	// useEffect(() => {
	// 	if (isInitialClearRender.current) return;

	// 	requestAnimationFrame(() => {
	// 		const stickyCheckboxWrapper = document.querySelector(
	// 			'[data-sticky-table] .selectionHeader .p-checkbox'
	// 		) as HTMLElement | null;

	// 		const stickyCheckboxBox = document.querySelector(
	// 			'[data-sticky-table] .selectionHeader .p-checkbox-box'
	// 		) as HTMLElement | null;

	// 		if (!stickyCheckboxWrapper || !stickyCheckboxBox) return;

	// 		stickyCheckboxWrapper.classList.remove("p-highlight");
	// 		stickyCheckboxBox.classList.remove("p-highlight");

	// 		stickyCheckboxBox.style.backgroundColor = "";
	// 		stickyCheckboxBox.style.borderColor = "";
	// 		stickyCheckboxBox.innerHTML = "";
	// 	});
	// }, [clearAllSelectedItemsForPayrollTable]);


	// const shouldProgressivelyRender = payrollItems.length > 15;

	// const [visibleRowCount, setVisibleRowCount] = useState(10);

	// useEffect(() => {
	// 	if (!shouldProgressivelyRender) {
	// 		setVisibleRowCount(payrollItems.length);
	// 		return;
	// 	}

	// 	setVisibleRowCount(15);

	// 	const interval = window.setInterval(() => {
	// 		setVisibleRowCount((current) => {
	// 			if (current >= payrollItems.length) {
	// 				window.clearInterval(interval);
	// 				return current;
	// 			}

	// 			return Math.min(current + 15, payrollItems.length);
	// 		});
	// 	}, 30);

	// 	return () => window.clearInterval(interval);
	// }, [payrollItems.length, shouldProgressivelyRender]);

	// const displayedPayrollItems = shouldProgressivelyRender
	// 	? payrollItems.slice(0, visibleRowCount)
	// 	: payrollItems;

	// const isAllPayrollItemsShown =
	// 	displayedPayrollItems.length === payrollItems.length;


	useEffect(() => {
		if (isInitialClearRender.current) return;
		clearStickyCheckboxHighlight();
	}, [clearAllSelectedItemsForPayrollTable]);


	const selectedEmployeeIds = useMemo(
		() =>
			new Set(
				selectedItems?.map(
					(item: any) => item.employeeId
				)
			),
		[selectedItems]
	);

	const columnBodies = useMemo(() => {
		const map = new Map();
		for (const column of sortedColumns) {
			map.set(column.field, (rowData: any, row: any) => columnsBody(rowData, row, column));
		}
		return map;
	}, [sortedColumns, columnsBody]);

	const getHeaderClassName = useCallback(
		(column: any) => {
			if (
				column.field === "vacationPay" ||
				column.field === "vacationPayAccured"
			) {
				return "vacationPayField";
			}

			if (
				column.field === "holidayHours" ||
				column.field === "holidayPayAccured" ||
				column.field === "holidayPay"
			) {
				return "holidayHoursField";
			}

			if (column.edr === "earnings") {
				return "earningsField";
			}

			if (column.edr === "deductions") {
				return "deductionsField";
			}

			if (column.edr === "reimbursements") {
				return "reimbursementsField";
			}

			return "";
		},
		[]
	);

	const getBodyClassName = useCallback(
		(rowData: any, column: any) => {
			if (rowData.salaryProfileMessage) {
				return "";
			}

			return getHeaderClassName(column);
		},
		[getHeaderClassName]
	);

	const payrollGridClassName = useMemo(() => {
		const classes = ["PayrollDataGrid"];

		if (isLoading) {
			if (selectedItems?.length > 0) {
				classes.push("payroll-grid-loading-selected");
			} else {
				classes.push("payroll-grid-loading-all");
			}
		}

		return classes.join(" ");
	}, [isLoading, selectedItems?.length]);

	const frozenColumnOffsets = useMemo(() => {
		const offsets = new Map<string, number>();
		let cumulativeLeft = 0;

		if (enableFrozenColumns && showChecboxColumn) {
			cumulativeLeft += 36; // selection column width
		}

		sortedColumns.forEach((col: any) => {
			if (enableFrozenColumns && col.frozenColumn) {
				offsets.set(col.field, cumulativeLeft);
				cumulativeLeft += Number(col.maxWidth) || 0;
			}
		});

		return offsets;
	}, [sortedColumns, enableFrozenColumns]);


	// this is for select all checkbox in footer bottom
	const handleSelectAllCheckbox = useCallback(
		(e: any) => {
			const isSelectAllChecked = e.checked;
			const allRowsSelected = rows || [];
			const allIds = allRowsSelected.map((item: any) => item.id);
			setManualSelectAll(isSelectAllChecked);
			setSelectedItems(isSelectAllChecked ? allRowsSelected : []);
			setSelectedItemsIds(isSelectAllChecked ? allIds : []);
		},

		[rows]
	);


	// When Save/Calculate kicks off a partial-selection loading state (skeleton
	// rows), the person likely scrolled down to reach the toolbar and can no
	// longer see the rows they selected. Scroll the FIRST selected row back
	// into view so they can see it go into (and come out of) the loading state.
	const prevIsLoadingRef = useRef(isLoading);

	useEffect(() => {
		const justStartedLoading = isLoading && !prevIsLoadingRef.current;
		prevIsLoadingRef.current = isLoading;

		if (!justStartedLoading) return;
		if (!selectedItems || selectedItems.length === 0) return;
		// Only for a PARTIAL selection — if all rows are selected, the person
		// already knows what's loading (the whole grid) and needs no scroll cue.
		if (!rows || selectedItems.length >= rows.length) return;

		const firstSelectedEmployeeId = selectedItems[0]?.employeeId;
		if (firstSelectedEmployeeId == null) return;

		const container = containerRef.current;
		if (!container) return;

		// Wait one frame so the loading/skeleton classes have actually painted
		// before we measure position.
		requestAnimationFrame(() => {
			const cell = container.querySelector(
				`[data-employee-id="${firstSelectedEmployeeId}"]`
			);
			const row = cell?.closest("tr");
			if (!row) return;

			const NAVBAR_HEIGHT = 112; // same constant as stickyHeaderManager.ts
			const EXTRA_GAP = 50;

			const rowRect = row.getBoundingClientRect();
			const targetTop =
				window.scrollY + rowRect.top - NAVBAR_HEIGHT - EXTRA_GAP;

			window.scrollTo({ top: targetTop, behavior: "smooth" });
		});
	}, [isLoading, selectedItems, rows]);


	return (
		<div
			// ref={containerRef}
			// onFocusCapture={handleGridFocus}
			// onBlurCapture={handleGridBlur}
			// onKeyDownCapture={handleGridKeyDown}
			// style={{
			// 	width: "100%",
			// 	overflow: "hidden", // container stays fixed
			// 	background: "#fff"
			// }}

			ref={containerRef}
			onFocusCapture={handleGridFocus}
			onClick={handleGridClick}
			onBlurCapture={handleGridBlur}
			onKeyDownCapture={handleGridKeyDown}
			style={{
				// width: "100%",
				background: "#fff",
				width: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%",
				minWidth: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%"
			}}
		>
			<DataTable
				// value={rows && columns && payrollItems}
				value={payrollItems}
				// value={displayedPayrollItems}



				// responsiveLayout="scroll"
				// showGridlines
				// // resizableColumns
				// columnResizeMode="expand"
				// scrollable={enableFrozenColumns}
				// scrollHeight="calc(100vh - 190px)"
				// virtualScrollerOptions={{
				// 	itemSize: 42,
				// 	numToleratedItems: 10,
				// }}


				// scrollHeight={tableScrollHeight ? "75vh" : ""}
				// reorderableColumns
				// loading={isLoading || loading}
				// key={isLoading}
				// footer={footer ? footer : undefined}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className={payrollGridClassName}
				style={{
					margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				}}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				// selectionMode="multiple"
				selectionMode="checkbox"
				sortMode="single"
				/** 👇 Force fixed table layout so width styles are respected */
				// tableStyle={{ tableLayout: 'fixed', width: '100%' }}
				// tableStyle={{
				// 	tableLayout: 'fixed',
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : '100%',
				// }}
				// tableStyle={{
				// 	tableLayout: totalColumnWidth < containerWidth ? "fixed" : "auto",
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : "100%"
				// }}


				// tableStyle={{
				// 	tableLayout: shouldFitContainer ? "fixed" : "auto",
				// 	width: shouldFitContainer
				// 		? `${totalColumnWidth}px`
				// 		: "100%",
				// }}
				tableStyle={
					useFitContainerLogic
						? {
							tableLayout: shouldFitContainer ? "fixed" : "auto",
							width: shouldFitContainer
								? `${totalColumnWidth}px`
								: "100%",
						}
						: {
							tableLayout: "fixed",
							// width: "100%",
							width: `${totalColumnWidth}px`,
						}
				}

			// tableStyle={{
			// 	tableLayout: "fixed",
			// 	width: "100%",
			// }}

			// onCellClick={(e) => alert("clicked")}
			// rowClassName={getRowClassName}
			// onSort={onSort}
			>
				{columns && rows && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						// frozen={enableFrozenColumns}
						resizeable={false}
						// style={{ width: "36px", textAlign: "center" }}
						style={{
							width: "36px",
							textAlign: "center",
							...(enableFrozenColumns
								? {
									position: "sticky" as const,
									left: "0px",
									// zIndex: 6, 
									background: "#fff"
								}
								: {}),
						}}
						field="selection"
						columnKey="selection"
						className={"selectionHeader"}
						headerClassName={"selectionHeader"}

						// this is for select all checkbox in footer bottom
						footer={() =>
							showChecboxColumn ? (
								<div>
									<Checkbox
										checked={manualSelectAll}
										onChange={(e: any) =>
											handleSelectAllCheckbox({ checked: e.target.checked })
										}
									/>
								</div>
							) : (
								<div />
							)
						}
					></Column>
				)}
				{/* {columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0)) */}
				{sortedColumns.map((x: any, index: any) => {
					const isFrozen = enableFrozenColumns && x.frozenColumn;
					const frozenLeft = frozenColumnOffsets.get(x.field) ?? 0;
					return (
						<Column
							key={x.field ?? index}
							field={x.field}
							header={x.headerName}
							// headerTooltip={x.description}
							// headerTooltipOptions={{ position: "top" }}
							// hidden={x.hide}
							// sortable={x.sortable}
							// reorderable={false}
							// dataType={x.type}
							align={x.align}
							// alignHeader={x.headerAlign}
							// exportable={x.disableExport}


							// frozen={totalColumnWidth < containerWidth ? false : x.frozenColumn}
							// frozen={
							// 	shouldFitContainer
							// 		? false
							// 		: x.frozenColumn
							// }
							// frozen={
							// 	useFitContainerLogic
							// 		? (shouldFitContainer ? false : x.frozenColumn)
							// 		: x.frozenColumn
							// }


							// frozen={enableFrozenColumns ? x.frozenColumn : false}
							// alignFrozen={x.alignFrozen}
							columnKey={x.field}
							// style={{
							// 	minWidth: x.minWidth,
							// 	fontSize: "0.875rem",
							// 	width: x.maxWidth,
							// 	maxWidth: x.maxWidth,
							// 	// width: x.maxWidth,
							// }}
							style={{
								minWidth: x.minWidth,
								fontSize: "0.875rem",
								width: x.maxWidth,
								maxWidth: x.maxWidth,
								...(isFrozen
									? {
										position: "sticky" as const,
										left: `${frozenLeft}px`,
										// zIndex: 5, 
										background: "#fff"
									}
									: {}),
							}}

							// headerStyle={{
							// 	whiteSpace: whiteSpace ? whiteSpace : "nowrap",
							// }}
							headerStyle={{
								whiteSpace: whiteSpace ? whiteSpace : "nowrap",
								...(isFrozen
									? {
										position: "sticky" as const,
										left: `${frozenLeft}px`,
										// zIndex: 6, 
										background: "#fff"
									}
									: {}),
							}}
							headerClassName={
								x.field === 'vacationPay' ? 'vacationPayField' :
									x.field === 'vacationPayAccured' ? 'vacationPayField' :
										x.field === 'holidayHours' ? 'holidayHoursField' :
											x.field === 'holidayPayAccured' ? 'holidayHoursField' :
												x.field === 'holidayPay' ? 'holidayHoursField' :
													x.edr === 'earnings' ? 'earningsField' :
														x.edr === 'deductions' ? 'deductionsField' :
															x.edr === 'reimbursements' ? 'reimbursementsField' :
																isFrozen ? ' sticky-frozen-th' :
																	''}
							// className={
							// 	x.field === 'vacationPay' ? 'vacationPayField' :
							// 		x.field === 'vacationPayAccured' ? 'vacationPayField' :
							// 			x.field === 'holidayHours' ? 'holidayHoursField' :
							// 				x.field === 'holidayPayAccured' ? 'holidayHoursField' :
							// 					x.field === 'holidayPay' ? 'holidayHoursField' :
							// 						x.edr === 'earnings' ? 'earningsField' :
							// 							x.edr === 'deductions' ? 'deductionsField' :
							// 								x.edr === 'reimbursements' ? 'reimbursementsField' :
							// 									''}
							bodyClassName={(rowData: any, row: any) =>
								x.field === "vacationPay" && !rowData.salaryProfileMessage
									? "vacationPayField"
									: x.field === "vacationPayAccured" && !rowData.salaryProfileMessage
										? "vacationPayField"
										: x.field === "holidayHours" && !rowData.salaryProfileMessage
											? "holidayHoursField"
											: x.field === "holidayPayAccured" && !rowData.salaryProfileMessage
												? "holidayHoursField"
												: x.field === "holidayPay" && !rowData.salaryProfileMessage
													? "holidayHoursField"
													: x.edr === "earnings" && !rowData.salaryProfileMessage
														? "earningsField"
														: x.edr === "deductions" && !rowData.salaryProfileMessage
															? "deductionsField"
															: x.edr === "reimbursements" && !rowData.salaryProfileMessage
																? "reimbursementsField"
																: ""
							}
							// bodyClassName={x.cellClassName}

							footer={x.footer}
							// body={(rowData: any, row: any) =>
							// 	columnsBody(rowData, row, x)
							// }
							// body={(rowData: any, row: any) => {
							// 	if (isLoading) {
							// 		// If rows are selected, only show skeleton on selected rows
							// 		if (selectedItems && selectedItems.length > 0) {
							// 			// const isSelected = selectedItems.some(
							// 			// 	(item: any) => item.employeeId === rowData.employeeId
							// 			// );
							// 			const isSelected = selectedEmployeeIds.has(rowData.employeeId);
							// 			return isSelected ? <Box sx={{ height: "38px", alignItems: "center", display: "flex" }}><Skeleton height="1.4rem" /></Box> : columnsBody(rowData, row, x);
							// 		}
							// 		// No selection — skeleton on all rows
							// 		return <Skeleton height="1.5rem" />;
							// 	}
							// 	return columnsBody(rowData, row, x);
							// }}

							// body={(rowData: any, row: any) => {
							// 	if (isLoading) {
							// 		// If rows are selected, only show skeleton on selected rows
							// 		if (selectedItems && selectedItems.length > 0) {
							// 			// const isSelected = selectedItems.some(
							// 			// 	(item: any) => item.employeeId === rowData.employeeId
							// 			// );
							// 			const isSelected =
							// 				selectedEmployeeIds.has(rowData.employeeId);
							// 			return isSelected ? <Box sx={{ height: "38px", alignItems: "center", display: "flex" }}><Skeleton height="1.4rem" /></Box> : columnsBody(rowData, row, x);
							// 		}
							// 		// No selection — skeleton on all rows
							// 		return <Skeleton height="1.5rem" />;
							// 	}
							// 	// return columnsBody(rowData, row, x);
							// 	return columnsBody(rowData, row, x);
							// }}

							// body={renderColumnBody(x)}

							// headerClassName={getHeaderClassName(x)}
							// bodyClassName={getBodyClassName}

							body={columnBodies.get(x.field)}

						/>
					);
				})}
			</DataTable>
		</div>
	);
};
